/* eslint-disable no-useless-escape */
/* eslint-disable no-fallthrough */
import ExtensionService from "./ExtensionService";
import * as moment from "moment";
import readXlsxFile from "read-excel-file";
import Excel from "exceljs";
import FileSaver from "file-saver";
import { blockUi, unblockUi } from "../shared/utils";
import { store } from '../store/store';
import _ from "lodash";
import { Filter } from "mushroomjs"

let MethodService = {};

MethodService.generateId = function (length) {
  var crypto = require("crypto");
  return crypto.randomBytes(length || 12).toString('hex');
}

MethodService.formatCurrency = (value) => {
  if (MethodService.isNumber(value)) {
    return value.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.')
  } else {
    return value
  }
}

MethodService.getRandomColor = function () {
  return "#" + Math.floor(Math.random() * 16777215).toString(16);
}

// roles: ["AdminSystem","Customer"]
MethodService.checkRole = function (stringRoles) {
  var currentUser = store.state.currentUser;
  let roles = stringRoles.split(",");
  var flag = false;
  roles.forEach(function (item) {
    item = item.trim();
    if (currentUser.roles.indexOf(item) != -1) {
      flag = true;
    }
  });
  return flag;
};

MethodService.getValidJobInfo = (jobInfor, arrValidContractIds) => {
  if (!arrValidContractIds) arrValidContractIds = []
  let curentTime = new Date().getTime()
  return jobInfor.filter((e) => {
    if (!arrValidContractIds.includes(e.contract_type_id)) return false
    if (e.end_date) {
      return (
        new Date(e.start_date).getTime() <= curentTime &&
        curentTime <= new Date(e.end_date).getTime()
      )
    } else {
      return new Date(e.start_date).getTime() <= curentTime;
    }
  })
}
MethodService.getFutureJobInfo = (jobInfor, arrValidContractIds) => {
  if (!arrValidContractIds) arrValidContractIds = []
  let curentTime = new Date().getTime()
  return jobInfor.filter((e) => {
    if (!arrValidContractIds.includes(e.contract_type_id)) return false
    if (e.end_date) {
      return (
        new Date(e.start_date).getTime() > curentTime &&
        curentTime <= new Date(e.end_date).getTime()
      )
    } else {
      return new Date(e.start_date).getTime() > curentTime
    }
  })
}
MethodService.getValidShiftInfo = (shifts) => {
  let curentTime = new Date().getTime()
  let currentTimeAdd1 = new Date(moment(new Date()).add(1, 'days').toDate()).getTime()
  return shifts.filter((e) => {
    if (e.end_time) {
      return (
        new Date(e.start_time).getTime() <= currentTimeAdd1 &&
        curentTime <= new Date(e.end_time).getTime()
      );
    } else {
      return new Date(e.start_time).getTime() <= curentTime;
    }
  })
}

MethodService.getFutureShiftInfo = (shifts) => {
  let curentTime = new Date().getTime()
  return shifts.filter((e) => {
    if (e.end_time) {
      return (
        new Date(e.start_time).getTime() > curentTime &&
        curentTime <= new Date(e.end_time).getTime()
      );
    } else {
      return new Date(e.start_time).getTime() > curentTime;
    }
  })
}

MethodService.getExpriedJobInfo = (jobInfor, arrValidContractIds) => {
  if (!arrValidContractIds) arrValidContractIds = []
  let curentTime = new Date().getTime();
  return jobInfor.filter((e) => {
    if (!arrValidContractIds.includes(e.contract_type_id)) return false
    if (!e.end_date) return false
    return (
      new Date(e.start_date).getTime() < curentTime &&
      new Date(e.end_date).getTime() < curentTime
    )
  })
}

MethodService.getLongTermJobInfo = (jobInfor, arrValidContractIds) => {
  if (!arrValidContractIds) arrValidContractIds = []
  let curentTime = new Date().getTime()
  let currentTimeAdd30 = new Date(moment(new Date()).add(30, 'days').toDate()).getTime()
  return jobInfor.filter((e) => {
    if (!arrValidContractIds.includes(e.contract_type_id)) return false
    if (new Date(e.start_date).getTime() <= curentTime && !e.end_date) return true
    return new Date(e.start_date).getTime() <= curentTime && new Date(e.end_date).getTime() > currentTimeAdd30
  })
}

MethodService.getWeeksInMonth = function (month, year) {
  var firstOfMonth = new Date(year, month, 1);
  var lastOfMonth = new Date(year, month + 1, 0);
  var used = firstOfMonth.getDay() + lastOfMonth.getDate();
  return Math.ceil(used / 7);
}

MethodService.calculatorSeniority = (startWorkingDate) => {
  if (!startWorkingDate) return 0
  let startWorkingDateMoment = moment(startWorkingDate)
  let now = moment()
  return now.diff(startWorkingDateMoment, "years") < 0 ? 0 : now.diff(startWorkingDateMoment, "years")
}

MethodService.checkHaveFeature = function (featureCode) {
  let listFeature = store.state.listFeature;
  let result = listFeature.find(item => item == featureCode);
  return result ? true : false;
};

MethodService.checkHavePermission = function (permissionCode) {
  if (!MethodService.checkHaveFeature(permissionCode)) {
    toastr.options.timeOut = 10000;
    toastr.warning("Bạn không có quyền truy cập chức năng này");
    setTimeout(() => {
      toastr.options.timeOut = 3500;
    }, 500)
  }
}

MethodService.moveObjectInArray = (arr, old_index, new_index) => {
  arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
  return arr;
};
MethodService.sortByName = (data, field) => {
  return data.sort((a, b) => {
    let nameA = _.get(a, `${field}`).toUpperCase();
    let nameB = _.get(b, `${field}`).toUpperCase();
    return nameA.localeCompare(nameB);
  });
}

MethodService.getAge = (birthday) => {
  if (!birthday) return 0;
  let ageDifMs = Date.now() - new Date(birthday).getTime();
  let ageDate = new Date(ageDifMs);
  return Math.abs(ageDate.getUTCFullYear() - 1970) + 1;
}
MethodService.checkWidthHeightImage = async (fileId, maxWidth, maxHeight) => {
  if (!fileId) return false
  const img = new Image();
  img.src = ExtensionService.urlImg + fileId;
  const result = await new Promise((resolve, reject) => {
    img.onload = () => {
      if ((img.width > maxWidth) && (img.height > maxHeight)) {
        resolve({
          file_id: fileId,
          status: false,
          message: "Kích thước ảnh không được vượt quá " + maxWidth + "x" + maxWidth + "px"
        });
      } else if (img.width > maxWidth) {
        resolve({
          file_id: fileId,
          status: false,
          message: "Chiều dài ảnh không được vượt quá " + maxWidth + "px"
        });
      } else if (img.height > maxHeight) {
        resolve({
          file_id: fileId,
          status: false,
          message: "Chiều rộng ảnh không được vượt quá " + maxHeight + "px"
        });
      } else {
        resolve({
          file_id: fileId,
          status: true,
          message: ""
        });
      }
    };
    img.onerror = (err) => {
      reject(err);
    }
  });
  return result;
}
MethodService.totalWorkDayInMonth = (totalWeek, totalDayWork) => {

}
MethodService.getWidthHeightImage = async (fileId) => {
  if (!fileId) return null
  const img = new Image()
  img.src = ExtensionService.urlImg + fileId;
  const result = await new Promise((resolve, reject) => {
    img.onload = () => {
      resolve({
        width: img.width,
        height: img.height
      });
    };
    img.onerror = (err) => {
      reject(err);
    }
  });
  return result;

};

MethodService.getCurrentDate = function () {
  return new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 23, 59, 59).toISOString()
};

MethodService.getFirstDayOfMonth = function (time) {
  let date = new Date(time), y = date.getFullYear(), m = date.getMonth()
  return new Date(y, m, 1)
}

MethodService.getLastDayOfMonth = function (time) {
  let date = new Date(time), y = date.getFullYear(), m = date.getMonth()
  return new Date(y, m + 1, 0, 23, 59, 59)
}

MethodService.trimSpace = function (value) {
  return value.trim();
};
MethodService.getCurrentUser = function () {
  return store.state.currentUser;
};
MethodService.getCompanyInfo = function () {
  return store.state.companyInfo;
};

MethodService.getListFeatures = function () {
  return store.state.listFeature;
};

MethodService.getListEmployeeRoleIds = function () {
  return store.state.listEmployeeRoleIds;
};

MethodService.getListEmployeeRoles = function () {
  return store.state.listEmployeeRoles;
};

MethodService.getCurrentEmployeeRoleCode = function () {
  return store.state.currentEmployeeRoleCode;
};

MethodService.getUserProfile = function () {
  return store.state.userProfile;
};

MethodService.getEmployeeInfo = function () {
  return store.state.employeeInfo;
};

MethodService.getNavSubMenus = function () {
  return store.state.navSub
};

//Encode HTML
MethodService.encodeHTML = function (str) {
  return str
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
};

//Decode HTML
MethodService.decodeHTML = function (str) {
  return str
    .replace(/&amp;/g, "&")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&quot;/g, '"')
    .replace(/&#039;/g, "'");
}

//Merge field in Contract template
MethodService.mergeField = function (template, objMergeFileds) {
  let result = template;
  for (let key in objMergeFileds) {
    result = result.replaceAll(`${key}`, objMergeFileds[key] ? objMergeFileds[key] : ".....................");
  }
  return result;
}

//required iso 9001 ex: yyyy-dd-mmThh:mm:ssZ
let formatDateMonth = "MM/YYYY";
let formatDateMoment = "DD/MM/YYYY";
let formatDateMoment2 = "YYYY/MM/DD";

//ex: iso date to string date  yyyy-dd-mmThh:mm:ssZ - > DD/MM/YYYY
//ex: new Date to iso date  Wed Mar 25 2015 07:00:00 GMT+0700 (Giờ Đông Dương) - > yyyy-dd-mmThh:mm:ssZ || MethodService.formatDate(new Date, "")

MethodService.formatDateNoSignal = function (value) {
  let time = value.split(" ");
  let datearray = time[0].split("/");
  let timeArray = time[1].split(":");
  return datearray[0] + datearray[1] + datearray[2] + timeArray[0] + timeArray[1];
};

MethodService.formatterYYYYMMDD = function (value) {
  let datearray = value.split("/");
  return datearray[2] + "/" + datearray[1] + "/" + datearray[0];
};

MethodService.formatterMMDDYYYY = function (value) {
  let datearray = value.split("/");
  return datearray[1] + "/" + datearray[0] + "/" + datearray[2];
};

MethodService.formatterYYYYmmDD = function (value) {
  let datearray = value.split("/");
  return datearray[2] + "-" + datearray[1] + "-" + datearray[0];
};

MethodService.formatDateYYYYMMDD = function (value, rule) {
  if (value) {
    var format = "";
    if (rule == "date") {
      format = formatDateMoment2;
    } else if (rule == "datetime") {
      format = formatDateMoment2 + " HH:mm";
    } else if (rule == "aboutTime") {
      format = formatDateMoment2 + " HH:mm";
    } else if (rule == "month") {
      format = formatDateMonth;
    } else {
      format = rule;
    }
    return moment(value).format(format);
  } else {
    return "";
  }
};
MethodService.minus7hour = (value) => {
  let date = new Date(value);
  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours() - 7, date.getMinutes(), date.getMilliseconds());

};

MethodService.formatDateToMilliseconds = function (date) {
  let m = new Date(date);
  let dateString =
    ("0" + m.getDate()).slice(-2) + "/" +
    ("0" + (m.getMonth() + 1)).slice(-2) + "/" +
    m.getFullYear() + " " +
    ("0" + m.getHours()).slice(-2) + ":" +
    ("0" + m.getMinutes()).slice(-2) + ":" +
    ("0" + m.getSeconds()).slice(-2) + "." +
    m.getMilliseconds();
  return dateString;
};

MethodService.formatDateToSeconds = function (date) {
  let m = new Date(date);
  let dateString =
    ("0" + m.getDate()).slice(-2) + "/" +
    ("0" + (m.getMonth() + 1)).slice(-2) + "/" +
    m.getFullYear() + " " +
    ("0" + m.getHours()).slice(-2) + ":" +
    ("0" + m.getMinutes()).slice(-2) + ":" +
    ("0" + m.getSeconds()).slice(-2);
  return dateString;
};

MethodService.formatDate = function (value, rule) {
  if (value) {
    var format = "";
    if (rule == "date") {
      format = formatDateMoment;
    } else if (rule == "datetime") {
      format = formatDateMoment + " HH:mm";
    } else if (rule == "timedate") {
      format = "HH:mm " + formatDateMoment;
    } else if (rule == "aboutTime") {
      format = formatDateMoment + " HH:mm:ss";
    } else if (rule == "month") {
      format = formatDateMonth;
    } else {
      format = rule;
    }
    return moment(new Date(value)).format(format);
  } else {
    return "";
  }
};

MethodService.formatDateUTC = function (value, rule) {
  if (value) {
    var format = "";
    if (rule == "date") {
      format = formatDateMoment;
    } else if (rule == "datetime") {
      format = formatDateMoment + " HH:mm";
    } else if (rule == "aboutTime") {
      format = formatDateMoment + " HH:mm";
    } else if (rule == "month") {
      format = formatDateMonth;
    } else {
      format = rule;
    }
    return moment(new Date(value))
      .utc()
      .format(format);
  } else {
    return "";
  }
};

MethodService.formatTimestamp = function (value, rule) {
  if (value) {
    var format = "";
    if (rule == "date") {
      format = formatDateMoment;
    } else if (rule == "datetime") {
      format = formatDateMoment + " HH:mm";
    } else if (rule == "aboutTime") {
      format = formatDateMoment + " HH:mm";
    } else {
      format = rule;
    }
    return moment(value, "YYYY:MM:DDTHH:mm:ss.SSSZZ").format(format);
  } else {
    return "";
  }
};

MethodService.getAboutTime = function (value) {
  if (value) {
    let timeAgo = moment(value).fromNow();
    timeAgo = timeAgo
      .replace("a few seconds ago", "vài giây trước")
      .replace("minutes ago", "phút trước")
      .replace("hours ago", "giờ trước");
    return timeAgo;
  } else {
    return "";
  }
};

MethodService.addDate = function (value, type, numberTime) {
  if (!value) {
    return "";
  }
  return moment(value)
    .add(numberTime, type)
    .format("YYYY-MM-DDTHH:mm:ss");
};

MethodService.formatterTrimString = function (
  row,
  column,
  cellValue,
  index,
  number
) {
  if (!number) {
    number = 8;
  }
  var lengthAllow = (column.width ? column.width : column.realWidth) / number;
  if (cellValue) {
    if (cellValue.length > lengthAllow) {
      return cellValue.slice(0, lengthAllow) + "...";
    } else {
      return cellValue;
    }
  } else {
    return "";
  }
};

MethodService.formatterFloatNumber = function (row, column, cellValue, index) {
  if (cellValue) {
    cellValue = parseFloat(cellValue).toFixed(2);
    return cellValue.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  }
};

MethodService.stringToObject = function (value) {
  var obj = {};
  if (!value) return obj;

  value.split("&").forEach(frm => {
    var m = decodeURIComponent(frm).match(
      /^(\w+(\.\w+)*)(=|>=|<=|<>|!=|:\w+:)(.*)/
    );
    if (!m) return;
    if (m[1] in obj) return;
    if (m[3].match(/:regex(_\w+)?:/)) obj[m[1]] = unescapeRegex(m[4]);
    else obj[m[1]] = m[4];
  });

  return obj;
};

MethodService.CalculationYear = function (type, last, next) {
  var toGo = "";
  var yearNow = new Date();
  var limit = yearNow.getFullYear();
  if (type == "last") {
    toGo = last;
  }
  if (type == "next") {
    toGo = next;
    limit = limit + next - 1;
  }
  if (type == "last-next") {
    toGo = next + last;
    limit = limit + next - 1;
  }
  var arr = [];
  for (let i = 0; i < toGo; i++) {
    arr.push(limit - i);
  }
  return arr;
};

MethodService.beforeAvatarUpload = function (file, mb) {
  return file.size / 1024 / 1024 < mb;
};

MethodService.EndYearBind = function (startYear) {
  let arr = [];
  let setYear = new Date();
  let yearPresent = setYear.getFullYear();

  if (startYear) {
    let rangToYearStart = yearPresent - startYear;
    if (rangToYearStart <= 20) {
      for (let i = rangToYearStart; i >= 1; i--) {
        arr.push(startYear + i);
      }
    } else {
      for (let i = 20; i <= 1; i) {
        arr.push(startYear + i);
      }
    }
  } else {
    for (let i = 0; i < 20; i++) {
      arr.push(yearPresent - i);
    }
  }

  return arr;
};

MethodService.StartYearBind = function (endYear) {
  let arr = [];
  let setYear = new Date();
  let yearPresent = setYear.getFullYear();
  if (endYear) {
    let rangToYearStart = endYear - Number(2000);
    if (rangToYearStart <= 20)
      for (let i = 1; i < rangToYearStart; i++) {
        arr.push(endYear - i);
      }
  } else {
    for (let i = 1; i < 20; i++) {
      arr.push(yearPresent - i);
    }
  }
  return arr;
};

MethodService.stopLadda = function () {
  setTimeout(function () {
    window.Ladda.stopAll();
  }, 100);
};

MethodService.checkFileSize = function (file, mb) {
  return file.size / 1024 / 1024 < mb;
}

MethodService.checkMaxFileSize = function (file, mb) {
  return file.size / 1024 / 1024 > mb;
}

MethodService.checkFileType = function (type) {
  let typeFile = ["mp4", "jpg", "png", "jpeg", "mp4", "avi", "mov"];
  if (typeFile.includes(type)) {
    return true;
  } else {
    return false;
  }
};

MethodService.isString = function (value) {
  return typeof value === "string" || value instanceof String;
};

MethodService.isNumber = function (value) {
  return typeof value === "number" && isFinite(value);
};

MethodService.isArray = function (value) {
  return value && typeof value === "object" && value.constructor === Array;
};

MethodService.isFunction = function (value) {
  return typeof value === "function";
};

MethodService.isObject = function (value) {
  return value && typeof value === "object" && value.constructor === Object;
};

MethodService.isDate = function (value) {
  return value instanceof Date;
};

MethodService.isBoolean = function (value) {
  return typeof value === "boolean";
};

MethodService.isNull = function (value) {
  return value === null;
};

MethodService.isUndefined = function (value) {
  return typeof value === "undefined";
};

MethodService.checkIsDate = function (day, month, year) {
  var d = parseInt(day);
  var m = parseInt(month);
  var y = parseInt(year);

  var date = new Date(y, m - 1, d);
  if (
    date.getFullYear() == y &&
    date.getMonth() + 1 == m &&
    date.getDate() == d
  ) {
    return true;
  }
  return false;
};

MethodService.copyObject = function (value) {
  return JSON.parse(JSON.stringify(value));
};

MethodService.findDuplicates = (arr) => {
  let sorted_arr = arr.slice().sort(); // You can define the comparing function here.
  // JS by default uses a crappy string compare.
  // (we use slice to clone the array so the
  // original array won't be modified)
  let results = [];
  for (let i = 0; i < sorted_arr.length - 1; i++) {
    if (sorted_arr[i + 1] == sorted_arr[i]) {
      results.push(sorted_arr[i]);
    }
  }
  return results;
}

// so sánh 2 object khởi tạo và object trả về, nếu trả về thiếu trường thì lấy trường từ object khởi tạo gán vào objetc trả về
MethodService.checkDifferentObject = function (objectOld, objectNew) {
  function forObject(objectOld) {
    $.each(objectOld, function (key_objectOld, value_objectOld) {
      if (MethodService.isUndefined(objectNew[key_objectOld])) {
        objectNew[key_objectOld] = objectOld[key_objectOld];
      } else if (MethodService.isNull(objectNew[key_objectOld])) {
        objectNew[key_objectOld] = objectOld[key_objectOld];
      } else {
        if (MethodService.isObject(value_objectOld)) {
          forObject(value_objectOld);
        }
      }
    });
  }
  forObject(objectOld);
  return objectNew;
};

// Tìm các phần tử khác nhau có trong mảng object trả về [],
// nếu truyền [object] thì truyển thêm field
// nếu truyền array thì k cần
MethodService.findListItemDifferent = function (arrItem, field) {
  let arrItemNew = [];
  if (field) {
    $.each(arrItem, (index, item) => {
      if (field) {
        if (item[field]) {
          if (arrItemNew.indexOf(item[field]) == -1) {
            arrItemNew.push(item[field]);
          }
        }
      } else {
        if (arrItemNew.indexOf(item) == -1) {
          arrItemNew.push(item);
        }
      }
    });
    return arrItemNew;
  } else {
    return arrItem.filter((item, index) => {
      return arrItem.indexOf(item) === index;
    });
  }
};

MethodService.findListItemDuplicate = function (arrItem1, arrItem2) {
  return arrItem1.filter(function (val) {
    return arrItem2.indexOf(val) != -1;
  });
};

MethodService.replaceURLImage = function (value) {
  return value.replace(/(!\[[^\]]*\])\([\w.\-\/:]+file\/thumb\?id=([0-9a-fA-F]{24})\)/g, "$1($2)")
};

MethodService.unreplaceURLImage = function (value) {
  return value.replace(
    /!\[([^\]]*)\]\(([0-9a-fA-F]{24})\)/g,
    `![$1](${ExtensionService.urlImg}$2)`
  );
};

MethodService.checkSDT = function (value) {
  return RegExp(/^(0|\+?84|0084)\d{9}$/).test(value);
};

MethodService.mathRound = (value) => {
  return Math.round(value * 100) / 100;
};

MethodService.toIsoDate = function (value) {
  return moment(value).format("YYYY-MM-DDTHH:mm:ss.SSSZZ");
};

function unescapeRegex(string) {
  return string.replace(/\\([-\/\\^$*+?.()|[\]{}])/g, "$1");
}

MethodService.filterTable = function (jsonFilter) {
  if (!jsonFilter) return ""
  let dataSearch = JSON.parse(jsonFilter)
  let vn_text = '';
  let arrFilters = Object.entries(dataSearch.value).map(entry => {
    const [key, value] = entry
    if (!value) return
    if (!dataSearch.operator || !dataSearch.operator[key]) return Filter.eq(key, value)
    let operator = dataSearch.operator[key]
    switch (operator) {
      case "<+1day":
        return Filter.lt(key, MethodService.addDate(value, "days", 1))
      case "$vn_text=":
        vn_text = '&$vn_text=' + encodeURIComponent(value);
        return null;
      case ":in_that_day:":
        return Filter.and(
          Filter.gte(key, value),
          Filter.lt(key, MethodService.addDate(value, "days", 1))
        )
      case ":in:":
        return Filter.in(key, value)
      case ":regex_i:":
        return Filter.regex(key, value)
      case "fromTime":
        return Filter.lte(key, value)
      case "toTime":
        return Filter.gte(key, value)
      case "is_null":
        return Filter.isNull(key, value)
      // eslint-disable-next-line no-case-declarations
      case "contract_validity_period":
        let arrFields = key.split("*")
        let arrIds = dataSearch.value['job_info.contract_type_id'].split(',')
        if (value == "validated") {
          return Filter.elementMatch('job_info', [
            Filter.in("contract_type_id", arrIds),
            Filter.and(
              Filter.lte(arrFields[0], '$$now'),
              Filter.or(
                Filter.gte(arrFields[1], '$$now'),
                Filter.isNull(arrFields[1]),
              )
            )
          ])
        } else if (value == 'about_to_expire') {
          const filter1 = Filter.nelementMatch('job_info', [
            Filter.in("contract_type_id", arrIds),
            Filter.or(
              Filter.isNull(arrFields[1]),
              Filter.gte(arrFields[1], '$$now+1months')
            )
          ])
          const filter2 = Filter.elementMatch('job_info', [
            Filter.in("contract_type_id", arrIds),
            Filter.and(
              Filter.lte(arrFields[0], '$$now'),
              Filter.and(
                Filter.gte(arrFields[1], '$$now'),
                Filter.lte(arrFields[1], '$$now+1months')
              )
            )
          ])
          return Filter.and(filter1, filter2)
        } else if (value == 'expired') {
          return Filter.nelementMatch('job_info', [
            Filter.in("contract_type_id", arrIds),
            Filter.or(
              Filter.isNull(arrFields[1]),
              Filter.gte(arrFields[1], MethodService.getCurrentDate())
            )
          ])
        }
      // eslint-disable-next-line no-case-declarations
      case "start_work":
        let arrValue = value.split('-')
        if (arrValue[0] == '0') { //0-1 năm kinh nghiệm
          return Filter.or(
            Filter.isNull(key),
            Filter.and(
              Filter.lt(key, '$$now-1years'),
              Filter.gt(key, '$$now'),
            )
          )
        } else if (arrValue[1] == '0') { //7+ năm kinh nghiệm
          return Filter.lte(key, '$$now-7years')
        } else {
          return Filter.and(
            Filter.lte(key, `$$now-${arrValue[0]}years`),
            Filter.gt(key, `$$now-${arrValue[1]}years`),
          )
        }
      default:
        break
    }
  }).filter(e => e)
  // console.log('Filter.and(arrFilters).build()', Filter.and(arrFilters).build())
  // console.log('JSON.stringify(Filter.and(arrFilters))', JSON.stringify(Filter.and(arrFilters)))
  return Filter.and(arrFilters).build() + vn_text;
};

MethodService.changeAlias = function (alias) {
  var str = alias.toLowerCase();
  str = str.toLowerCase();
  str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
  str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
  str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
  str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
  str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
  str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
  str = str.replace(/đ/g, "d");
  str = str.replace(
    /!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g,
    " "
  );
  str = str.replace(/ + /g, " ");
  str = str.trim();
  return str;
};

MethodService.formatCurrency = value => {
  if (MethodService.isNumber(value)) {
    return value.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
  } else {
    return value;
  }
};
MethodService.readExcel = async (dataFile, preferredSheet) => {
  if (preferredSheet) {
    blockUi()
    try {
      const workbook = new Excel.Workbook();
      await workbook.xlsx.load(await dataFile.arrayBuffer());
      const sheet = workbook.worksheets.find(item => item.name.trim().toLowerCase() === preferredSheet.trim().toLowerCase()) || workbook.worksheets[0];
      const rows = [];
      sheet.eachRow({ includeEmpty: true }, row => rows.push(row.values.slice(1)));
      return rows;
    } catch (error) {
      window.toastr.error("Đọc file thất bại. Vui lòng thử lại")
      throw error;
    } finally {
      unblockUi()
    }
  }
  return new Promise(function (resolve, reject) {
    blockUi()
    readXlsxFile(dataFile, { dateFormat: 'dd/mm/yyyy hh:mm' }).then((rows) => {
      resolve(rows)
      unblockUi()
    }, (error) => {
      window.toastr.error("Đọc file thất bại. Vui lòng thử lại")
      unblockUi()
      reject(error)
    });
  })
};

MethodService.styleRowExcel = (worksheet) => {
  worksheet.getRow(1).height = 30;
  worksheet.eachRow({ includeEmpty: true }, (row, rowNumber) => {
    row.eachCell(function (cell, colNumber) {
      if (rowNumber == 1) {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFE162" }
        };
        cell.font = { bold: true };
        cell.alignment = {
          vertical: "middle",
          horizontal: "center",
          wrapText: true
        };
      } else {
        cell.alignment = {
          vertical: "middle",
          wrapText: true
        };
      }
      // Set border of each cell
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" }
      };
    });
  });
  return worksheet;
}
MethodService.styleRowAnotherExcel = (worksheet) => {
  worksheet.getRow(5).height = 31;
  worksheet.eachRow({ includeEmpty: true }, (row, rowNumber) => {
    row.eachCell(function (cell, colNumber) {
      if (rowNumber == 5) {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFE162" }
        };
        cell.font = { bold: true };
        cell.alignment = {
          vertical: "middle",
          horizontal: "center",
          wrapText: true
        };
      } else {
        cell.alignment = {
          vertical: "middle",
          wrapText: true
        };
        if (rowNumber > 5 && (colNumber === 1 || colNumber === 3 || colNumber === 4)) {
          cell.alignment.horizontal = "center"
        }
      }
      // Set border of each cell
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" }
      };
    });
  });
  return worksheet;
}

MethodService.exportExcel = async (dataList) => {
  let workbook = MethodService.createWookbook();
  const employeeIdentityColumns = [
    { header: "Mã nhân viên", key: "employee_no", width: 15 },
    { header: "Họ và tên", key: "full_name", width: 30 }
  ];
  const assignEmployeeIdentity = (item, element) => {
    item.employee_no = element.employee_no;
    item.full_name = element.full_name
      ? element.full_name
      : [element.last_name, element.first_name].filter((value) => value).join(" ").trim();
    return item;
  };

  let worksheet = workbook.addWorksheet("Thông tin chung", {
    views: [{ state: "frozen", xSplit: 3, ySplit: 1 }]
  });

  worksheet.columns = [
    ...employeeIdentityColumns,
    { header: "Ngày sinh", key: "birthday", width: 15 },
    { header: "Giới tính", key: "gender", width: 12 },
    { header: "Số điện thoại", key: "phone_number", width: 18 },
    { header: "Email cá nhân", key: "email", width: 40 },
    { header: "Email công ty", key: "company_email", width: 40 },
    { header: "Ngày vào công ty", key: "start_work_date_display", width: 18 },
    { header: "Người quản lý trực tiếp", key: "direct_manager_name", width: 30 },
    { header: "Số CMND/CCCD", key: "identify_card", width: 15 },
    { header: "Địa chỉ", key: "address", width: 70 },
    { header: "Hợp đồng", key: "contract_name", width: 30 },
    { header: "Chức vụ", key: "position_name", width: 30 },
    { header: "Phòng ban", key: "department_name", width: 30 },
    { header: "Chi nhánh", key: "branch_name", width: 30 },
    { header: "Ca làm việc", key: "shift_name", width: 30 },
    { header: "Ngày bắt đầu", key: "start_date", width: 20 },
    { header: "Ngày kết thúc", key: "end_date", width: 20 },
    { header: "Trạng thái", key: "status", width: 20 },
  ];

  window.$.each(dataList, (index, element) => {
    let item = assignEmployeeIdentity({}, element);
    item.birthday = element.birthday ? new Date(element.birthday) : "";
    item.gender = element.gender;
    item.phone_number = element.phone_number ? element.phone_number : "";
    item.email = element.email ? element.email : "";
    item.company_email = element.company_email ? element.company_email : "";
    item.start_work_date_display = element.start_work_date_display ? element.start_work_date_display : "";
    item.direct_manager_name = element.direct_manager_name ? element.direct_manager_name : "";
    item.identify_card = element.administrative_info.identify_card ? element.administrative_info.identify_card : "";
    item.address = element.administrative_info.address ? element.administrative_info.address : "";
    item.status = element.status;
    item.contract_name = element.contract_name;
    item.position_name = element.position_name;
    item.department_name = element.department_name;
    item.branch_name = element.branch_name;
    item.start_date = element.start_date;
    item.end_date = element.end_date;
    item.shift_name = element.shift_name;
    worksheet.addRow(item);
  });

  let sheetQualification = workbook.addWorksheet("Trình độ chuyên môn", {
    views: [{ state: "frozen", xSplit: 3, ySplit: 1 }]
  });

  sheetQualification.columns = [
    ...employeeIdentityColumns,
    { header: "Trình độ", key: "qualification_name", width: 30 },
    { header: "Chuyên ngành", key: "major_name", width: 30 },
    { header: "Ngày cấp", key: "qualification_issued_date", width: 20 },
    { header: "Nơi cấp", key: "qualification_issued_by", width: 30 },
    { header: "Ghi chú", key: "qualification_note", width: 30 },
  ];

  window.$.each(dataList, (index, element) => {
    let item = assignEmployeeIdentity({}, element);
    item.qualification_name = element.qualification_name;
    item.major_name = element.major_name;
    item.qualification_issued_date = element.qualification_issued_date;
    item.qualification_issued_by = element.qualification_issued_by;
    item.qualification_note = element.qualification_note;
    sheetQualification.addRow(item);
  });

  let sheetCertificate = workbook.addWorksheet("Chứng chỉ", {
    views: [{ state: "frozen", xSplit: 3, ySplit: 1 }]
  });

  sheetCertificate.columns = [
    ...employeeIdentityColumns,
    { header: "Tên chứng chỉ", key: "certificate_name", width: 30 },
    { header: "Ngày cấp", key: "certificate_issued_date", width: 20 },
    { header: "Nơi cấp", key: "certificate_issued_by", width: 30 },
    { header: "Ghi chú", key: "certificate_note", width: 30 }
  ];

  window.$.each(dataList, (index, element) => {
    let item = assignEmployeeIdentity({}, element);
    item.certificate_name = element.certificate_name;
    item.certificate_issued_date = element.certificate_issued_date;
    item.certificate_issued_by = element.certificate_issued_by;
    item.certificate_note = element.certificate_note;
    sheetCertificate.addRow(item);
  });

  let sheetOtherContactInfo = workbook.addWorksheet("Thông tin liên hệ khác", {
    views: [{ state: "frozen", xSplit: 3, ySplit: 1 }]
  });

  sheetOtherContactInfo.columns = [
    ...employeeIdentityColumns,
    { header: "Họ và tên", key: "other_contact_info_name", width: 30 },
    { header: "Quan hệ", key: "other_contact_info_relationship", width: 30 },
    { header: "Điện thoại", key: "other_contact_info_phone", width: 30 },
    { header: "Địa chỉ", key: "other_contact_info_address", width: 30 }
  ];

  window.$.each(dataList, (index, element) => {
    let item = assignEmployeeIdentity({}, element);
    item.other_contact_info_name = element.other_contact_info_name;
    item.other_contact_info_relationship = element.other_contact_info_relationship;
    item.other_contact_info_phone = element.other_contact_info_phone;
    item.other_contact_info_address = element.other_contact_info_address;
    sheetOtherContactInfo.addRow(item);
  });

  let sheetSalary = workbook.addWorksheet("Lương Trợ cấp", {
    views: [{ state: "frozen", xSplit: 3, ySplit: 1 }]
  });

  sheetSalary.columns = [
    ...employeeIdentityColumns,
    { header: "Hình thức chi trả", key: "payment_method", width: 28 },
    { header: "Số tài khoản", key: "bank_account", width: 25 },
    { header: "Ngân hàng", key: "bank_name", width: 30 },
    { header: "Chi nhánh", key: "bank_branch", width: 30 },
    { header: "Bậc lương", key: "rank_salary", width: 30 },
    { header: "Hệ số lương", key: "coefficient_salary", width: 30 },
    { header: "Lương Gross", key: "gross_salary", width: 25 },
    { header: "Đóng bảo hiểm", key: "insurance_salary", width: 25 },
    { header: "Trợ cấp", key: "subsidies_salary_name", width: 35 },
  ];

  window.$.each(dataList, (index, element) => {
    let item = assignEmployeeIdentity({}, element);
    item.payment_method = element.payment_method;
    item.bank_account = element.bank_account;
    item.bank_name = element.bank_name;
    item.bank_branch = element.bank_branch;
    item.rank_salary = element.rank_salary;
    item.coefficient_salary = element.coefficient_salary;
    item.gross_salary = element.gross_salary;
    item.insurance_salary = element.insurance_salary;
    item.subsidies_salary_name = element.subsidies_salary_name;
    sheetSalary.addRow(item);
  });

  let sheetDependentPerson = workbook.addWorksheet("Thông tin người phụ thuộc", {
    views: [{ state: "frozen", xSplit: 3, ySplit: 1 }]
  });

  sheetDependentPerson.columns = [
    ...employeeIdentityColumns,
    { header: "Họ và tên", key: "dependent_person_name", width: 30 },
    { header: "Quan hệ", key: "dependent_person_relationship", width: 25 },
    { header: "Ngày đăng ký", key: "dependent_person_registered_date", width: 20 },
    { header: "Ngày hết hạn", key: "dependent_person_expired_date", width: 20 }
  ];

  window.$.each(dataList, (index, element) => {
    let item = assignEmployeeIdentity({}, element);
    item.dependent_person_name = element.dependent_person_name;
    item.dependent_person_relationship = element.dependent_person_relationship;
    item.dependent_person_registered_date = element.dependent_person_registered_date;
    item.dependent_person_expired_date = element.dependent_person_expired_date;
    sheetDependentPerson.addRow(item);
  });

  MethodService.styleRowExcel(worksheet);
  MethodService.styleRowExcel(sheetQualification);
  MethodService.styleRowExcel(sheetCertificate);
  MethodService.styleRowExcel(sheetOtherContactInfo);
  MethodService.styleRowExcel(sheetSalary);
  MethodService.styleRowExcel(sheetDependentPerson);
  let nowDate = MethodService.formatDateNoSignal(
    MethodService.formatDate(new Date(), "datetime")
  );
  workbook.xlsx.writeBuffer().then(function (data) {
    var blob = new Blob([data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    });
    FileSaver.saveAs(blob, `DanhSachNhanVien_${nowDate}.xlsx`);
  });
};

MethodService.addAnotherSheetEmployee = (workbook, data, name, headers, keys) => {
  let sheet = workbook.addWorksheet(name, {
    views: [{ state: "frozen", xSplit: 3, ySplit: 1 }]
  });
  sheet.columns = [];
  headers.forEach((item, index) => {
    sheet.columns.push({
      header: item,
      key: keys[index]
    });
  })
  data.forEach((e, i) => {
    let item = {};
    keys.forEach(key => {
      item[key] = e[key] ? e[key] : "";
    })
    sheet.addRow(item);
  });

  MethodService.styleRowExcel(sheet);
  return sheet;

}

MethodService.createWookbook = () => {
  let workbook = new Excel.Workbook();
  workbook.created = new Date();
  workbook.calcProperties.fullCalcOnLoad = false;
  workbook.views = [{
    x: 0,
    y: 0,
    width: 10000,
    height: 20000,
    firstSheet: 0,
    activeTab: 0,
    visibility: "visible"
  }];
  return workbook
}

MethodService.addAnotherSheet = (workbook, data, name, headers) => {
  let sheet = workbook.addWorksheet(name, {
    views: [{ state: "frozen", ySplit: 1 }]
  });
  sheet.state = "hidden";

  sheet.columns = [
    { header: headers[0], key: "code", width: 20 },
    { header: headers[1], key: "name", width: 30 },
  ];
  $.each(data, (i, e) => {
    let item = {};
    item.code = e.code ? e.code : "";
    item.name = e.name ? e.name : "";
    sheet.addRow(item);
  });

  MethodService.styleRowExcel(sheet);

  return sheet
}

MethodService.exportTemplateImportEmployee = async function (listDataEm, listBranch, listDeparterment, listPosition, listHopDong, type) {
  let workbook = MethodService.createWookbook();
  let worksheetEmployee = workbook.addWorksheet("Nhan_Vien", {
    views: [{ state: "frozen", xSplit: 3, ySplit: 1 }]
  });
  worksheetEmployee.columns = [
    { header: "Mã nhân viên*", key: "employee_no", width: 20 },
    { header: "Họ và tên đệm *", key: "first_name", width: 25 },
    { header: "Tên *", key: "last_name", width: 20 },
    { header: "Giới tính *", key: "gender", width: 15 },
    { header: "Số điện thoại", key: "phone", width: 25 },
    { header: "Email *", key: "email", width: 20 },
    { header: "Số CMND", key: "identify_card", width: 15 },
    { header: "Ngày sinh", key: "birthday", width: 20 },
    { header: "Địa chỉ", key: "address", width: 20 },
    { header: "Tài khoản đăng nhập *", key: "account", width: 25 },
    { header: "Mã hợp đồng *", key: "contract_type_code", width: 20 },
    { header: "Hợp đồng", key: "contract_type", width: 25 },
    { header: "Mã chức vụ", key: "position_code", width: 20 },
    { header: "Chức vụ", key: "position", width: 20 },
    { header: "Mã phòng ban", key: "departerment_code", width: 20 },
    { header: "Phòng ban", key: "departerment", width: 20 },
    { header: "Mã chi nhánh", key: "branch_code", width: 20 },
    { header: "Chi nhánh", key: "branch", width: 20 },
    { header: "Ngày bắt đầu*", key: "time_start", width: 20 },
    { header: "Ngày kết thúc", key: "time_end", width: 20 },
    type && type == 'error' ? { header: "Thông báo lỗi", key: "message", width: 50 } : {}
  ];
  worksheetEmployee.getRow(1).height = 20;
  let row = worksheetEmployee.getRow(1);
  row.eachCell(function (cell, colNumber) {
    row.getCell(colNumber).font = { bold: true };
    row.getCell(colNumber).alignment = {
      vertical: "middle",
      horizontal: "center"
    };
  });
  if (!listDataEm || listDataEm.length == 0) {
    for (let i = 0; i < 2000; i++) {
      worksheetEmployee.addRow().commit();
    }
  } else if (listDataEm && listDataEm.length > 0) {
    $.each(listDataEm, (i, e) => {
      let item = {};
      item.employee_no = e.EmployeeNo ? e.EmployeeNo : "";
      item.first_name = e.FirstName ? e.FirstName : "";
      item.last_name = e.LastName ? e.LastName : "";
      item.gender = e.Gender ? e.Gender : "";
      item.phone = e.PhoneNumber ? e.PhoneNumber : "";
      item.email = e.Email ? e.Email : "";
      item.identify_card = e.IdentifyCard ? e.IdentifyCard : "";
      item.birthday = e.Birthday ? MethodService.formatDate(e.Birthday, 'date') : "";
      item.address = e.Address ? e.Address : "";
      item.account = e.Account ? e.Account : "";
      item.contract_type_code = e.ContractTypeCode ? e.ContractTypeCode : "";
      item.contract_type = e.ContractTypeName ? e.ContractTypeName : "";
      item.position_code = e.PositionCode ? e.PositionCode : "";
      item.position = e.PositionName ? e.PositionName : "";
      item.departerment_code = e.DepartmentCode ? e.DepartmentCode : "";
      item.departerment = e.DepartmentName ? e.DepartmentName : "";
      item.branch_code = e.BranchCode ? e.BranchCode : "";
      item.branch = e.BranchName ? e.BranchName : "";
      item.time_start = e.StartDate ? MethodService.formatDate(e.StartDate, 'date') : "";
      item.time_end = e.EndDate ? MethodService.formatDate(e.EndDate, 'date') : "";
      item.message = e.messages ? e.messages : "";
      worksheetEmployee.addRow(item);
    });
  }
  worksheetEmployee.eachRow({ includeEmpty: true }, (row, rowNumber) => {
    row.eachCell(function (cell, colNumber) {
      if (rowNumber == 1) {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFE162" }
        };
        cell.font = { bold: true };
        cell.alignment = {
          vertical: "middle",
          horizontal: "center",
          wrapText: true
        };
      } else {
        cell.alignment = {
          vertical: "middle",
          wrapText: true
        };
      }
      // Set border of each cell
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" }
      };
    });
  });
  worksheetEmployee.getCell('A1').note = {
    texts: [
      {
        'font': {
          'bold': true, 'size': 11, 'color': { 'theme': 1 },
          'name': 'Calibri', 'family': 2, 'scheme': 'minor'
        },
        'text': `'Chỉ nhập từ A-Z, 0-9'`
      },
    ],
    margins: {
      insetmode: 'custom',
      inset: [0.2, 0.2, 0.2, 0.2]
    },
  };
  worksheetEmployee.getCell('J1').note = {
    texts: [
      {
        'font': {
          'bold': true, 'size': 11, 'color': { 'theme': 1 },
          'name': 'Calibri', 'family': 2, 'scheme': 'minor'
        },
        'text': "Nhập từ 4-12 ký tự"
      },
    ],
    margins: {
      insetmode: 'custom',
      inset: [0.2, 0.2, 0.2, 0.2]
    },
  };
  worksheetEmployee.getCell('S1').note = {
    texts: [
      {
        'font': {
          'bold': true, 'size': 11, 'color': { 'theme': 1 },
          'name': 'Calibri', 'family': 2, 'scheme': 'minor'
        },
        'text': "Định dạng ngày là DD/MM/YYYY"
      },
    ],
    margins: {
      insetmode: 'custom',
      inset: [0.2, 0.2, 0.2, 0.2]
    },
  };
  worksheetEmployee
    .getColumn("D")
    .eachCell({ includeEmpty: true }, function (cell, rowNumber) {
      if (rowNumber != 1) {
        cell.dataValidation = {
          type: "list",
          allowBlank: true,
          formulae: ['"Nam,Nữ,Khác"']
        };
      }
    });
  worksheetEmployee
    .getColumn("K")
    .eachCell({ includeEmpty: true }, function (cell, rowNumber) {
      if (rowNumber != 1) {
        cell.dataValidation = {
          type: "list",
          allowBlank: true,
          formulae: ["ContractType!$A$2:$A$2000"]
        };
      }
    });
  worksheetEmployee
    .getColumn("L")
    .eachCell({ includeEmpty: true }, function (cell, rowNumber) {
      if (rowNumber != 1) {
        cell.value = { formula: `IF(K${rowNumber} = "", "", VLOOKUP(K${rowNumber},ContractType!$A$2:$B$2000,2,0))` }
      }
    });
  worksheetEmployee
    .getColumn("M")
    .eachCell({ includeEmpty: true }, function (cell, rowNumber) {
      if (rowNumber != 1) {
        cell.dataValidation = {
          type: "list",
          allowBlank: true,
          formulae: ["Position!$A$2:$A$2000"]
        };
      }
    });
  worksheetEmployee
    .getColumn("N")
    .eachCell({ includeEmpty: true }, function (cell, rowNumber) {
      if (rowNumber != 1) {
        cell.value = { formula: `IF(M${rowNumber} = "", "", VLOOKUP(M${rowNumber},Position!$A$2:$B$2000,2,0))` }
      }
    });
  worksheetEmployee
    .getColumn("O")
    .eachCell({ includeEmpty: true }, function (cell, rowNumber) {
      if (rowNumber != 1) {
        cell.dataValidation = {
          type: "list",
          allowBlank: true,
          formulae: ["Departerment!$A$2:$A$2000"]
        };
      }
    });
  worksheetEmployee
    .getColumn("P")
    .eachCell({ includeEmpty: true }, function (cell, rowNumber) {
      if (rowNumber != 1) {
        cell.value = { formula: `IF(O${rowNumber} = "", "", VLOOKUP(O${rowNumber},Departerment!$A$2:$B$2000,2,0))` }
      }
    });
  worksheetEmployee
    .getColumn("Q")
    .eachCell({ includeEmpty: true }, function (cell, rowNumber) {
      if (rowNumber != 1) {
        cell.dataValidation = {
          type: "list",
          allowBlank: true,
          formulae: ["Branch!$A$2:$A$2000"]
        };
      }
    });
  worksheetEmployee
    .getColumn("R")
    .eachCell({ includeEmpty: true }, function (cell, rowNumber) {
      if (rowNumber != 1) {
        cell.value = { formula: `IF(Q${rowNumber} = "", "", VLOOKUP(Q${rowNumber},Branch!$A$2:$B$2000,2,0))` }
      }
    });
  worksheetEmployee
    .getColumn("P")
    .eachCell({ includeEmpty: true }, function (cell, rowNumber) {
      if (rowNumber != 1) {
        cell.dataValidation = {
          type: 'date',
          operator: 'lessThan',
          showErrorMessage: true,
          allowBlank: false,
          formulae: [new Date(2200, 0, 1)]
        };
      }
    });
  worksheetEmployee
    .getColumn("S")
    .eachCell({ includeEmpty: true }, function (cell, rowNumber) {
      if (rowNumber != 1) {
        cell.dataValidation = {
          type: 'date',
          operator: 'lessThan',
          showErrorMessage: true,
          allowBlank: true,
          formulae: [new Date(2200, 0, 1)]
        };
      }
    });
  await this.addAnotherSheet(workbook, listHopDong, "ContractType", ["Mã hợp đồng", "Tên hợp đồng"]);
  await this.addAnotherSheet(workbook, listPosition, "Position", ["Mã chức vụ", "Tên chức vụ"]);
  await this.addAnotherSheet(workbook, listDeparterment, "Departerment", ["Mã phòng ban", "Tên phòng ban"]);
  await this.addAnotherSheet(workbook, listBranch, "Branch", ["Mã chi nhánh", "Tên chi nhánh"]);


  workbook.xlsx.writeBuffer().then(function (data) {
    var blob = new Blob([data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    });
    FileSaver.saveAs(blob, type == 'template' ? `Template_Import_Employee.xlsx` : "Error_Import_Employee.xlsx");
  });
}

MethodService.exportTemplateImportWork = async (listShift) => {
  let workbook = MethodService.createWookbook();
  let worksheetWork = workbook.addWorksheet("Import công", {
    // views: [{ state: "frozen", ySplit: 1 }]
  });
  worksheetWork.columns = [
    { header: "Mã nhân viên *", key: "first_name", width: 20 },
    { header: "Thời điểm từ *", key: "last_name", width: 25 },
    { header: "Thời điểm đến *", key: "gender", width: 25 },
    { header: "Mã ca *", key: "phone", width: 25 },
    { header: "Tên ca", key: "email", width: 38 },
    { header: "Lý do *", key: "account", width: 50 }
  ];
  worksheetWork.getRow(1).height = 20;
  for (let i = 0; i < 2000; i++) {
    worksheetWork.addRow().commit();
  }
  worksheetWork.eachRow({ includeEmpty: true }, (row, rowNumber) => {
    row.eachCell(function (cell, colNumber) {
      if (rowNumber == 1) {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFE162" }
        };
        cell.font = { bold: true };
        cell.alignment = {
          vertical: "middle",
          horizontal: "center",
          wrapText: true
        };
      } else {
        cell.alignment = {
          vertical: "middle",
          wrapText: true
        };
      }
      // Set border of each cell
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" }
      };
    });
  });
  worksheetWork.getCell('B1').note = {
    texts: [
      {
        'font': {
          'bold': true, 'size': 11, 'color': { 'theme': 1 },
          'name': 'Calibri', 'family': 2, 'scheme': 'minor'
        },
        'text': `Định dạng ngày là DD/MM/YYYY HH:mm`
      },
    ],
    margins: {
      insetmode: 'custom',
      inset: [0.2, 0.2, 0.2, 0.2]
    },
  };
  worksheetWork.getCell('C1').note = {
    texts: [
      {
        'font': {
          'bold': true, 'size': 11, 'color': { 'theme': 1 },
          'name': 'Calibri', 'family': 2, 'scheme': 'minor'
        },
        'text': `Định dạng ngày là DD/MM/YYYY HH:mm`
      },
    ],
    margins: {
      insetmode: 'custom',
      inset: [0.2, 0.2, 0.2, 0.2]
    },
  };
  await MethodService.addAnotherSheet(workbook, listShift, "Shift", ["Mã ca", "Tên ca"]);
  worksheetWork
    .getColumn("D")
    .eachCell({ includeEmpty: true }, function (cell, rowNumber) {
      if (rowNumber != 1) {
        cell.dataValidation = {
          type: "list",
          allowBlank: true,
          formulae: ["Shift!$A$2:$A$2000"]
        };
      }
    });
  worksheetWork
    .getColumn("E")
    .eachCell({ includeEmpty: true }, function (cell, rowNumber) {
      if (rowNumber != 1) {
        cell.value = { formula: `IF(D${rowNumber} = "", "", VLOOKUP(D${rowNumber},Shift!$A$2:$B$2000,2,0))` }
      }
    });
  workbook.xlsx.writeBuffer().then(function (data) {
    var blob = new Blob([data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    });
    FileSaver.saveAs(blob, 'Template_Import_Work.xlsx');
  });
}

MethodService.exportExcelWorkSynthetic = (data, salaryPeriod, options = {}) => {
  let workbook = MethodService.createWookbook();
  workbook.properties.ignoredError = {
    number_stored_as_text: true
  }
  let worksheet = workbook.addWorksheet(`Bảng công tổng hợp`);
  worksheet.columns = [
    { header: "STT", key: "index", width: 6 },
    { header: "Mã nhân viên", key: "employee_no", width: 18 },
    { header: "Họ tên", key: "employee_name", width: 25 },
    { header: "Chức vụ", key: "position_name", width: 24 },
    { header: "Công ty", key: "company_name", width: 24 },
    { header: "Chi nhánh", key: "branch_name", width: 24 },
    { header: "Phòng ban", key: "department_name", width: 24 },
    { header: "Tổng công của kỳ", key: "total_work_of_period", width: 15 },
    { header: "Ca làm việc", key: "shift_name", width: 24 },
    { header: "Tổng công làm việc thực tế", key: "total_work", width: 15 },
    { header: "Nghỉ lễ / tết", key: "day_off", width: 11 },
    { header: "Nghỉ phép", key: "paid_leave", width: 11 },
    { header: "Nghỉ không lương", key: "unpaid_leave", width: 11 },
    { header: "Online / Công tác", key: "online", width: 11 },
    { header: "Số ngày tính ăn trưa", key: "lunch_day_count", width: 15 },
    { header: "Tổng công tính lương", key: "total_salary_calculation", width: 12 },
    { header: "OT", key: "ot_time", width: 11 },
    { header: "Số lần đi muộn", key: "go_late_count", width: 11 },
    { header: "Tổng số phút đi muộn", key: "total_go_late_minutes", width: 15 },
    { header: "Số lần về sớm", key: "go_home_early_count", width: 11 },
    { header: "Tổng số phút về sớm", key: "total_go_home_early_minutes", width: 15 }
  ];
  data.forEach((item, index) => {
    let cellObj = {};
    cellObj.index = index + 1;
    cellObj.employee_no = item.employee_no;
    cellObj.employee_name = item.employee_name;
    cellObj.position_name = item.position_name;
    cellObj.company_name = item.company_name;
    cellObj.branch_name = item.branch_name;
    cellObj.department_name = item.department_name;
    cellObj.total_work_of_period = item.standard_work != undefined ? item.standard_work : 0;
    cellObj.shift_name = item.shift_code;
    cellObj.total_work = item.total_work;
    cellObj.day_off = item.day_off_count ? item.day_off_count : 0;
    cellObj.paid_leave = item.paid_leave ? item.paid_leave : 0;
    cellObj.unpaid_leave = item.unpaid_leave ? item.unpaid_leave : 0;
    cellObj.online = item.online && item.bussiness ? item.online + item.bussiness : 0;
    cellObj.lunch_day_count = item.lunch_day_count ? item.lunch_day_count : 0;
    cellObj.total_salary_calculation = item.total_salary_calculation ? item.total_salary_calculation : 0;
    cellObj.ot_time = item.ot_time ? item.ot_time : 0;
    cellObj.go_late_count = item.go_late_count ? item.go_late_count : 0;
    cellObj.total_go_late_minutes = item.total_go_late_minutes ? item.total_go_late_minutes : 0;
    cellObj.go_home_early_count = item.go_home_early_count ? item.go_home_early_count : 0;
    cellObj.total_go_home_early_minutes = item.total_go_home_early_minutes ? item.total_go_home_early_minutes : 0;
    worksheet.addRow(cellObj);
  })
  let date = new Date(salaryPeriod.before_to_date);
  const companyName = options.companyName
  const branchText = options.branchNames && options.branchNames.length
    ? options.branchNames.join(", ")
    : "Tất cả đơn vị";
  const departmentText = options.departmentNames && options.departmentNames.length
    ? options.departmentNames.join(", ")
    : "Tất cả phòng ban";
  worksheet.insertRow(1);
  worksheet.insertRow(2);
  worksheet.insertRow(3);
  worksheet.insertRow(4);
  worksheet.getRow(1).height = 17;
  worksheet.getRow(2).height = 17;
  worksheet.getRow(3).height = 17;
  worksheet.getRow(4).height = 17;
  worksheet.mergeCells(`A1:B1`);
  worksheet.mergeCells(`C1:F1`);
  worksheet.mergeCells(`A2:B2`);
  worksheet.mergeCells(`C2:F2`);
  worksheet.mergeCells(`A3:B3`);
  worksheet.mergeCells(`C3:F3`);
  worksheet.mergeCells(`A4:B4`);
  worksheet.mergeCells(`C4:F4`);
  worksheet.getRow(1).getCell(1).value = "Công ty";
  worksheet.getRow(1).getCell(3).value = companyName;
  worksheet.getRow(2).getCell(1).value = "Thời gian";
  worksheet.getRow(2).getCell(3).value = `Từ ${MethodService.formatDate(salaryPeriod.from_date, "date")} đến ${MethodService.formatDate(date.setDate(date.getDate() - 1), "date")}`;
  worksheet.getRow(3).getCell(1).value = "Đơn vị";
  worksheet.getRow(3).getCell(3).value = branchText;
  worksheet.getRow(4).getCell(1).value = "Phòng ban";
  worksheet.getRow(4).getCell(3).value = departmentText;

  worksheet.eachRow({ includeEmpty: true }, (row, rowNumber) => {
    row.eachCell(function (cell, colNumber) {
      if (rowNumber == 5) {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFE162" }
        };
        cell.font = { bold: true };
        cell.alignment = {
          vertical: "middle",
          horizontal: "center",
          wrapText: true
        };
      } else {
        cell.alignment = {
          vertical: "middle",
          wrapText: true
        };
        if (rowNumber > 5 && colNumber === 1) {
          cell.alignment.horizontal = "center"
        }
      }
      // Set border of each cell
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" }
      };
    });
  });
  workbook.xlsx.writeBuffer().then(function (data) {
    var blob = new Blob([data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    });
    FileSaver.saveAs(blob, `Bảng công tổng hợp tháng ${salaryPeriod.name}.xlsx`);
  });
}

MethodService.exportExcelWorkDetail = (data, salaryPeriod, options = {}) => {
  let workbook = MethodService.createWookbook();
  const date = new Date(salaryPeriod.before_to_date);
  const startDate = new Date(salaryPeriod.from_date);
  const month = startDate.getMonth() + 1;
  const year = startDate.getFullYear();
  const totalDayInMonth = new Date(year, month, 0).getDate();
  const worksheet = workbook.addWorksheet("Bảng công chi tiết", {
    views: [{ state: "frozen", xSplit: 3, ySplit: 5 }]
  });
  const columns = [
    { header: "Họ và tên", key: "employee_name", width: 32 },
    { header: "Ca làm việc", key: "shift_code", width: 18 },
    { header: "Công", key: "total_work", width: 10 }
  ];

  for (let day = 1; day <= totalDayInMonth; day++) {
    columns.push({
      header: buildWorkSheetDayLabel(year, month, day),
      key: `day_${day}`,
      width: 10
    });
  }

  worksheet.columns = columns;
  data.forEach((item) => {
    const cellValue = {
      employee_name: `${item.employee_no || ""} - ${item.full_name || ""}`.trim(),
      shift_code: item.shift_code || "",
      total_work: formatWorkSheetValue(item.total_work)
    };
    for (let day = 1; day <= totalDayInMonth; day++) {
      const workDay = (item.days || []).find((entry) => entry.date === day);
      cellValue[`day_${day}`] =
        workDay && workDay.work_value != undefined
          ? formatWorkSheetValue(workDay.work_value)
          : "";
    }
    worksheet.addRow(cellValue);
  });

  worksheet.insertRow(1);
  worksheet.insertRow(2);
  worksheet.insertRow(3);
  worksheet.insertRow(4);

  const lastColumnLetter = getExcelColumnName(columns.length);
  worksheet.getRow(1).height = 18;
  worksheet.getRow(2).height = 18;
  worksheet.getRow(3).height = 18;
  worksheet.getRow(4).height = 18;
  worksheet.getRow(5).height = 32;
  const companyName = options.companyName;
  const branchText = options.branchNames && options.branchNames.length
    ? options.branchNames.join(", ")
    : "Tất cả đơn vị";
  const departmentText = options.departmentNames && options.departmentNames.length
    ? options.departmentNames.join(", ")
    : "Tất cả phòng ban";
  worksheet.mergeCells(`B1:${lastColumnLetter}1`);
  worksheet.mergeCells(`B2:${lastColumnLetter}2`);
  worksheet.mergeCells(`B3:${lastColumnLetter}3`);
  worksheet.mergeCells(`B4:${lastColumnLetter}4`);
  worksheet.getRow(1).getCell(1).value = "Công ty";
  worksheet.getRow(1).getCell(2).value = companyName;
  worksheet.getRow(2).getCell(1).value = "Thời gian";
  worksheet.getRow(2).getCell(2).value = `Từ ${MethodService.formatDate(salaryPeriod.from_date, "date")} đến ${MethodService.formatDate(date.setDate(date.getDate() - 1), "date")}`;
  worksheet.getRow(3).getCell(1).value = "Đơn vị";
  worksheet.getRow(3).getCell(2).value = branchText;
  worksheet.getRow(4).getCell(1).value = "Phòng ban";
  worksheet.getRow(4).getCell(2).value = departmentText;

  worksheet.eachRow({ includeEmpty: true }, (row, rowNumber) => {
    row.eachCell((cell, colNumber) => {
      if (rowNumber === 5) {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "F79646" }
        };
        cell.font = {
          bold: true,
          color: { argb: "FFFFFF" }
        };
        cell.alignment = {
          vertical: "middle",
          horizontal: "center",
          wrapText: true
        };
      } else {
        cell.alignment = {
          vertical: "middle",
          wrapText: true
        };
        if (colNumber >= 2) {
          cell.alignment.horizontal = "center";
        }
      }
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" }
      };
    });
  });

  worksheet.autoFilter = {
    from: "A5",
    to: `${lastColumnLetter}5`
  };

  workbook.xlsx.writeBuffer().then(function (data) {
    var blob = new Blob([data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    });

    FileSaver.saveAs(blob, `Bảng công chi tiết tháng ${salaryPeriod.name}.xlsx`);
  });
}

function buildWorkSheetDayLabel(year, month, date) {
  const day = new Date(year, month - 1, date).getDay();
  if (day === 0) {
    return `CN (${date >= 10 ? date : "0" + date})`;
  }
  return `T${day + 1} (${date >= 10 ? date : "0" + date})`;
}

function formatWorkSheetValue(value) {
  return Math.round((value || 0) * 100) / 100;
}

function getExcelColumnName(index) {
  let result = "";
  let current = index;
  while (current > 0) {
    const remainder = (current - 1) % 26;
    result = String.fromCharCode(65 + remainder) + result;
    current = Math.floor((current - 1) / 26);
  }
  return result;
}

MethodService.exportTemplateImportSalary = (listEmployee) => {
  let workbook = MethodService.createWookbook();
  let worksheet = workbook.addWorksheet("Lương", {
    views: [{ state: "frozen", xSplit: 2, ySplit: 1 }]
  });
  worksheet.columns = [
    { header: "Mã nhân viên", key: "employee_no", width: 23 },
    { header: "Họ và tên", key: "last_name", width: 30 },
    { header: "Lương cơ bản", key: "space0", width: 20 },
    { header: "Phụ cấp trách nhiệm", key: "space1", width: 20 },
    { header: "Phụ cấp ăn trưa", key: "space2", width: 20 },
    { header: "Phụ cấp điện thoại", key: "space3", width: 20 },
    { header: "Phụ cấp xăng xe", key: "space4", width: 20 },
    { header: "Phụ cấp", key: "space5", width: 20 },
    { header: "Thưởng tháng", key: "space6", width: 20 },
    { header: "Phụ cấp thâm niên", key: "space7", width: 20 },
    { header: "Bảo hiểm xã hội (8%)", key: "space8", width: 17 },
    { header: "Bảo hiểm y tế (1,5%)", key: "space9", width: 17 },
    { header: "Bảo hiểm thất nghiệp (1%)", key: "space10", width: 20 },
    { header: "Bảo hiểm bắt buộc", key: "space11", width: 20 },
    { header: "Thuế thu nhập cá nhân", key: "space12", width: 20 },
    { header: "Tạm ứng", key: "space13", width: 20 },
    { header: "Khác", key: "space14", width: 20 },
    { header: "Tổng lương thực nhận  (*)", key: "space15", width: 20 },
  ];
  listEmployee.forEach(employee => {
    let item = {};
    item.employee_no = employee.employee_no ? employee.employee_no : "";
    item.last_name = employee.administrative_info && employee.administrative_info.name && employee.administrative_info.name.full_name ? employee.administrative_info.name.full_name : "";
    item.space0 = "";
    item.space1 = "";
    item.space2 = "";
    item.space3 = "";
    item.space4 = "";
    item.space5 = "";
    item.space6 = "";
    item.space7 = "";
    item.space8 = "";
    item.space9 = "";
    item.space10 = "";
    item.space11 = "";
    item.space12 = "";
    item.space13 = "";
    item.space14 = "";
    item.space15 = "";
    worksheet.addRow(item);
  });
  MethodService.styleRowExcel(worksheet);
  workbook.xlsx.writeBuffer().then(function (data) {
    var blob = new Blob([data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    });
    FileSaver.saveAs(blob, `Template Luong.xlsx`);
  });
}

MethodService.exportTemplateImportTax = (listEmployee) => {
  let workbook = MethodService.createWookbook()
  let worksheet = workbook.addWorksheet("Thuế", {
    views: [{ state: "frozen", xSplit: 2, ySplit: 1 }]
  })
  worksheet.columns = [
    { header: "Mã nhân viên (*)", key: "employee_no", width: 23 },
    { header: "Họ và tên", key: "last_name", width: 30 },
    { header: "Thu nhập chịu thuế", key: "space0", width: 25 },
    { header: "Giảm trừ gia cảnh", key: "space1", width: 25 },
    { header: "Ủng hộ", key: "space2", width: 25 },
    { header: "Bảo hiểm bắt buộc", key: "space3", width: 25 },
    { header: "Thu nhập tính thuế", key: "space4", width: 25 },
    { header: "Tỷ lệ giảm thuế TNCN do có TN tại khu kinh tế", key: "space5", width: 25 },
  ]
  listEmployee.forEach(employee => {
    let item = {}
    item.employee_no = employee.employee_no ? employee.employee_no : ""
    item.last_name = employee.administrative_info && employee.administrative_info.name && employee.administrative_info.name.full_name ? employee.administrative_info.name.full_name : ""
    item.space0 = ""
    item.space1 = ""
    item.space2 = ""
    item.space3 = ""
    item.space4 = ""
    item.space5 = ""
    worksheet.addRow(item)
  })
  MethodService.styleRowExcel(worksheet)
  workbook.xlsx.writeBuffer().then(function (data) {
    var blob = new Blob([data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    })
    FileSaver.saveAs(blob, `Template Thue.xlsx`);
  })
}

MethodService.exportTemplateImportInsurance = (listEmployee) => {
  let workbook = MethodService.createWookbook()
  let worksheet = workbook.addWorksheet("Bảo hiểm", {
    views: [{ state: "frozen", xSplit: 2, ySplit: 1 }]
  })
  worksheet.columns = [
    { header: "Mã nhân viên (*)", key: "employee_no", width: 23 },
    { header: "Họ và tên", key: "last_name", width: 30 },
    { header: "Bảo hiểm xã hội", key: "space0", width: 25 },
    { header: "Bảo hiểm y tế", key: "space1", width: 25 },
    { header: "Bảo hiểm thất nghiệp", key: "space2", width: 25 },
  ]
  listEmployee.forEach(employee => {
    let item = {}
    item.employee_no = employee.employee_no ? employee.employee_no : ""
    item.last_name = employee.administrative_info && employee.administrative_info.name && employee.administrative_info.name.full_name ? employee.administrative_info.name.full_name : ""
    item.space0 = ""
    item.space1 = ""
    item.space2 = ""
    worksheet.addRow(item)
  })
  MethodService.styleRowExcel(worksheet)
  workbook.xlsx.writeBuffer().then(function (data) {
    var blob = new Blob([data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    })
    FileSaver.saveAs(blob, `Template Bao Hiem.xlsx`);
  })
}

MethodService.exportTax = (dataExport, listSalaryPeriod, fromPeriod, toPeriod) => {
  let workbook = MethodService.createWookbook()
  let worksheet = workbook.addWorksheet("Thuế đã thu|Đã kê khai, Công nợ")
  worksheet.mergeCells(`B2:F2`)
  worksheet.getCell('B2').value = `Từ kỳ ${fromPeriod} đến kỳ ${toPeriod}`
  worksheet.addRow()
  worksheet.mergeCells(`B4:G4`)
  worksheet.getCell('A4').value = 'Tên kỳ'
  worksheet.getCell('B4').value = 'Thu nhập tính thuế TNCN'
  worksheet.getRow(2).height = 20
  worksheet.getRow(4).height = 25
  worksheet.getRow(5).height = 35
  worksheet.getRow(5).values = ['Kê khai theo mã nhân viên', 'Thu nhập chịu thuế', 'Giảm trừ gia cảnh', 'Ủng hộ', 'Bảo hiểm bắt buộc', 'Thu nhập tính thuế', 'Tỷ lệ giảm thuế TNCN do có TN tại khu kinh tế'];
  worksheet.columns = [
    { key: 'period', width: 23 },
    { key: 'income_tax', width: 23, style: { numFmt: '#,##0;[Red]-#,##0' } },
    { key: 'family_allowances', width: 23, style: { numFmt: '#,##0;[Red]-#,##0' } },
    { key: 'donate', width: 23, style: { numFmt: '#,##0;[Red]-#,##0' } },
    { key: 'compulsory_insurance', width: 23, style: { numFmt: '#,##0;[Red]-#,##0' } },
    { key: 'taxable_income', width: 23, style: { numFmt: '#,##0;[Red]-#,##0' } },
    { key: 'reduction_rate', width: 23, style: { numFmt: '#,##0;[Red]-#,##0' } },
  ]
  dataExport.forEach((item, index) => {
    worksheet.addRow({
      period: getNamePeriod(item.salary_period_id, listSalaryPeriod),
      income_tax: item.income_tax,
      family_allowances: item.family_allowances,
      donate: item.donate,
      compulsory_insurance: item.compulsory_insurance,
      taxable_income: item.taxable_income,
      reduction_rate: item.reduction_rate,
    })
  })
  styleIncomeInformationExxport(worksheet)
  workbook.xlsx.writeBuffer().then(function (data) {
    var blob = new Blob([data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    })
    FileSaver.saveAs(blob, `Thông tin Thuế.xlsx`);
  })
}

MethodService.exportInssurance = (dataExport, listSalaryPeriod, fromPeriod, toPeriod) => {
  let workbook = MethodService.createWookbook()
  let worksheet = workbook.addWorksheet("Trích nộp bảo hiểm")
  worksheet.mergeCells(`B2:D2`)
  worksheet.getCell('B2').value = `Từ kỳ ${fromPeriod} đến kỳ ${toPeriod}`
  worksheet.addRow()
  worksheet.mergeCells(`B4:E4`)
  worksheet.getCell('A4').value = 'Tên kỳ'
  worksheet.getCell('B4').value = 'Trích nộp bảo hiểm'
  worksheet.getRow(2).height = 20
  worksheet.getRow(4).height = 25
  worksheet.getRow(5).height = 35
  worksheet.getRow(5).values = ['Kê khai theo mã nhân viên', 'Bảo hiểm xã hội', 'Bảo hiểm y tế', 'Bảo hiểm thất nghiệp', 'Tổng']
  worksheet.columns = [
    { key: 'period', width: 23 },
    { key: 'social_insurance', width: 23, style: { numFmt: '#,##0;[Red]-#,##0' } },
    { key: 'health_insurance', width: 23, style: { numFmt: '#,##0;[Red]-#,##0' } },
    { key: 'unemployment_insurance', width: 23, style: { numFmt: '#,##0;[Red]-#,##0' } },
    { key: 'total', width: 23, style: { numFmt: '#,##0;[Red]-#,##0' } },
  ]
  dataExport.forEach((item, index) => {
    worksheet.addRow({
      period: getNamePeriod(item.salary_period_id, listSalaryPeriod),
      social_insurance: item.social_insurance,
      health_insurance: item.health_insurance,
      unemployment_insurance: item.unemployment_insurance,
      total: item.total,
    })
  })
  styleIncomeInformationExxport(worksheet)
  workbook.xlsx.writeBuffer().then(function (data) {
    var blob = new Blob([data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    })
    FileSaver.saveAs(blob, `Thông tin Bảo hiểm.xlsx`);
  })
}

function getNamePeriod(periodId, listSalaryPeriod) {
  if (periodId == 'Tổng cộng') return periodId
  let periodSalary = listSalaryPeriod.find(item => item.id == periodId)
  return periodSalary.name_period.replace('Tháng ', '')
}
function styleIncomeInformationExxport(worksheet) {
  worksheet.eachRow({ includeEmpty: true }, (row, rowNumber) => {
    row.eachCell((cell, colNumber) => {
      if (rowNumber == 2 || rowNumber == 4 || rowNumber == 5) {
        cell.font = {
          bold: true
        }
        cell.alignment = {
          vertical: "middle",
          horizontal: "center",
          wrapText: true
        }
        if (rowNumber == 2) {
          cell.font = {
            bold: true,
            size: 13
          }
        }
        if (rowNumber == 4) {
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "4f8aab" },
          }
          cell.font = {
            bold: true,
            color: { argb: 'FFFFFF' },
          }
        }
      } else {
        cell.alignment = {
          vertical: "middle",
          wrapText: true
        };
      }
      if (rowNumber > 2) {
        if (colNumber == 1) {
          cell.alignment = {
            vertical: "middle",
            horizontal: "center",
            wrapText: true
          }
          if (cell.value == 'Tổng cộng') {
            cell.font = {
              bold: true
            }
          }
        }
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" }
        }
      }
    })
  })
  return worksheet
}

MethodService.exportPersonalSalary = (data, namePeriod, from, to, myObject) => {
  let alphabet = 'GHIJKLMNOPQRSTUVWXYZ'.split('')
  let sizeKeyObj = Object.keys(myObject).length - 1
  let workbook = MethodService.createWookbook()
  let worksheet = workbook.addWorksheet("Thông tin lương")
  //Row1
  worksheet.mergeCells(`A1:B1`)
  worksheet.getCell('A1').value = `Kỳ chấm công`
  worksheet.mergeCells(`C1:F1`)
  worksheet.getCell('C1').value = `Ngày công`
  worksheet.mergeCells(`G1:${alphabet[sizeKeyObj]}1`)
  worksheet.getCell('G1').value = `Chi tiết thu nhập`
  worksheet.mergeCells(`A2:B2`)
  //Row2
  worksheet.getCell('A2').value = `Kỳ ${namePeriod}`
  worksheet.mergeCells(`C2:F2`)
  worksheet.getCell('C2').value = `Chi tiết ngày công`
  //Row3
  worksheet.getCell('A3').value = `Từ ngày`
  worksheet.getCell('B3').value = `Đến ngày`
  worksheet.getCell('C3').value = `Công chuẩn`
  worksheet.getCell('D3').value = `Công thực tế`
  worksheet.getCell('E3').value = `Ngày nghỉ hưởng lương`
  worksheet.getCell('F3').value = `Ngày nghỉ không hưởng lương`
  //Row 4
  worksheet.getCell('A4').value = from
  worksheet.getCell('B4').value = to
  worksheet.getCell('C4').value = data[0].totalStandardWork
  worksheet.getCell('D4').value = data[0].totalWork
  worksheet.getCell('E4').value = data[0].totalPaidLeave
  worksheet.getCell('F4').value = data[0].totalUnpaidLeave

  for (let i = 0; i <= sizeKeyObj; i++) {
    worksheet.getColumn(i + 7).width = 15
    worksheet.mergeCells(`${alphabet[i]}2:${alphabet[i]}3`)
    worksheet.getCell(`${alphabet[i]}3`).value = Object.keys(myObject)[i]
    worksheet.getCell(`${alphabet[i]}4`).value = Object.values(myObject)[i] ? parseInt(Object.values(myObject)[i]) : ''
    worksheet.getCell(`${alphabet[i]}4`).numFmt = '#,##0;[Red]-#,##0'
  }

  //Style
  worksheet.getRow(1).height = 23
  worksheet.getRow(2).height = 23
  worksheet.getRow(3).height = 33
  worksheet.getRow(4).height = 19
  for (let i = 1; i < 7; i++) {
    worksheet.getColumn(i).width = 18
  }
  worksheet.eachRow({ includeEmpty: true }, (row, rowNumber) => {
    row.eachCell((cell, colNumber) => {
      if (rowNumber <= 3) {
        cell.font = {
          bold: true
        }
        cell.alignment = {
          vertical: "middle",
          horizontal: "center",
          wrapText: true
        }
        if (rowNumber == 1) {
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "4f8aab" },
          }
          cell.font = {
            bold: true,
            color: { argb: 'FFFFFF' },
          }
        }
      } else {
        cell.alignment = {
          vertical: "middle",
          wrapText: true
        }
      }
      if (rowNumber > 3) {
        if (colNumber < 3) {
          cell.alignment = {
            vertical: "middle",
            horizontal: "center",
            wrapText: true
          }
        }
      }
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" }
      }
    })
  })
  workbook.xlsx.writeBuffer().then(function (data) {
    var blob = new Blob([data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    })
    FileSaver.saveAs(blob, `Thông tin lương ${namePeriod}.xlsx`);
  })
}

function saveExcelWorkbook(workbook, fileName) {
  workbook.xlsx.writeBuffer().then(function (data) {
    var blob = new Blob([data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    })
    FileSaver.saveAs(blob, fileName);
  })
}

function exportHtmlTableToWord({
  title,
  subtitle,
  headers,
  headerRows,
  rows,
  fileName,
  orientation = "landscape"
}) {
  const safeTitle = title || "";
  const safeSubtitle = subtitle || "";
  const safeHeaders = Array.isArray(headers) ? headers : [];
  const safeHeaderRows = Array.isArray(headerRows) ? headerRows : [];
  const safeRows = Array.isArray(rows) ? rows : [];
  const isLandscape = orientation === "landscape";
  const pageWidth = isLandscape ? "841.95pt" : "595.35pt";
  const pageHeight = isLandscape ? "595.35pt" : "841.95pt";
  const escapeHtml = (value) => `${value === undefined || value === null ? "" : value}`
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
  const renderHeaderCell = (cell) => {
    if (cell && typeof cell === "object" && !Array.isArray(cell)) {
      const colspan = Number(cell.colspan) > 1 ? ` colspan="${Number(cell.colspan)}"` : "";
      const rowspan = Number(cell.rowspan) > 1 ? ` rowspan="${Number(cell.rowspan)}"` : "";
      return `<th${colspan}${rowspan}>${escapeHtml(cell.label)}</th>`;
    }
    return `<th>${escapeHtml(cell)}</th>`;
  };
  const thead = safeHeaderRows.length > 0
    ? safeHeaderRows.map((row) => {
      const safeRow = Array.isArray(row) ? row : [];
      return `<tr>${safeRow.map((cell) => renderHeaderCell(cell)).join("")}</tr>`;
    }).join("")
    : `<tr>${safeHeaders.map((header) => renderHeaderCell(header)).join("")}</tr>`;
  const tbody = safeRows.map((row) => {
    return `<tr>${row.map((cell) => `<td>${escapeHtml(cell)}</td>`).join("")}</tr>`;
  }).join("");
  const html = `
    <html xmlns:o="urn:schemas-microsoft-com:office:office"
      xmlns:w="urn:schemas-microsoft-com:office:word"
      xmlns="http://www.w3.org/TR/REC-html40">
      <head>
        <meta charset="utf-8" />
        <title>${escapeHtml(safeTitle)}</title>
        <!--[if gte mso 9]>
        <xml>
          <w:WordDocument>
            <w:View>Print</w:View>
            <w:Zoom>100</w:Zoom>
          </w:WordDocument>
        </xml>
        <![endif]-->
        <style>
          @page {
            size: A4 ${orientation};
            margin: 12mm;
          }
          @page Section1 {
            size: ${pageWidth} ${pageHeight};
            mso-page-orientation: ${orientation};
            margin: 12mm;
          }
          body {
            font-family: Arial, sans-serif;
            color: #222;
            font-size: 11px;
          }
          div.Section1 {
            page: Section1;
          }
          h1 {
            margin: 0 0 8px 0;
            font-size: 18px;
            text-align: center;
          }
          .subtitle {
            margin: 0 0 12px 0;
            font-size: 11px;
            text-align: center;
          }
          table {
            width: 100%;
            border-collapse: collapse;
            table-layout: auto;
          }
          th, td {
            border: 1px solid #666;
            padding: 6px;
            vertical-align: middle;
            word-break: break-word;
          }
          th {
            background: #ffe162;
            text-align: center;
            font-weight: 700;
          }
        </style>
      </head>
      <body>
        <div class="Section1">
          <h1>${escapeHtml(safeTitle)}</h1>
          ${safeSubtitle ? `<div class="subtitle">${escapeHtml(safeSubtitle)}</div>` : ""}
          <table>
            <thead>${thead}</thead>
            <tbody>${tbody}</tbody>
          </table>
        </div>
      </body>
    </html>
  `;
  var blob = new Blob(["\ufeff", html], {
    type: "application/msword"
  });
  FileSaver.saveAs(blob, fileName);
}

const SALARY_COMPANY_EXPORT_SECTIONS = [
  {
    key: "stt",
    label: "STT",
    width: 8,
    fixed: true
  },
  {
    key: "employee_name",
    label: "Họ và tên",
    width: 26,
    fixed: true
  },
  {
    key: "position_name",
    label: "Chức vụ",
    width: 18
  },
  {
    key: "contract_type_name",
    label: "Loại hợp đồng",
    width: 22
  },
  {
    key: "branch_name",
    label: "Chi nhánh",
    width: 20
  },
  {
    key: "department_name",
    label: "Phòng ban",
    width: 22
  },
  {
    key: "attendance",
    label: "Ngày công",
    children: [
      { key: "standard_work", label: "Ngày công trong tháng", width: 18, format: "number" },
      { key: "actual_work", label: "Số công làm việc thực tế", width: 18, format: "number" },
      { key: "meal_allowance_day", label: "Ngày tính ăn trưa", width: 18, format: "number" },
      { key: "ot_150", label: "Số giờ làm thêm 150%", width: 18, format: "number" },
      { key: "ot_200", label: "Số giờ làm thêm 200%", width: 18, format: "number" },
      { key: "ot_300", label: "Số giờ làm thêm 300%", width: 18, format: "number" },
      { key: "paid_leave", label: "Nghỉ phép có lương", width: 18, format: "number" },
      { key: "unpaid_leave", label: "Nghỉ không lương", width: 18, format: "number" }
    ]
  },
  {
    key: "dependent_person",
    label: "Số người phụ thuộc",
    width: 18,
    format: "number"
  },
  {
    key: "salary_level",
    label: "Mức lương",
    width: 18,
    format: "currency"
  },
  {
    key: "insurance_salary",
    label: "Lương đóng bảo hiểm",
    width: 20,
    format: "currency"
  },
  {
    key: "income",
    label: "Chi tiết thu nhập",
    children: [
      { key: "salary_income", label: "Lương", width: 18, format: "currency" },
      { key: "ot_income", label: "OT", width: 18, format: "currency" },
      { key: "meal_allowance", label: "Ăn trưa", width: 18, format: "currency" },
      { key: "bonus", label: "Thưởng", width: 18, format: "currency" }
    ]
  },
  {
    key: "taxable_income",
    label: "Thu nhập tính thuế TNCN",
    width: 18,
    format: "currency"
  },
  {
    key: "deduction",
    label: "Các khoản giảm trừ",
    children: [
      { key: "insurance_total", label: "BHXH", width: 18, format: "currency" },
      { key: "tax_amount", label: "Thuế TNCN", width: 18, format: "currency" },
      { key: "meal_deduction", label: "Khấu trừ tiền ăn", width: 20, format: "currency" },
      { key: "reduction_other", label: "Khoản giảm trừ khác", width: 20, format: "currency" },
      { key: "advance_amount", label: "Tạm ứng", width: 18, format: "currency" }
    ]
  },
  {
    key: "total_income",
    label: "Tổng lương thực nhận",
    width: 20,
    format: "currency"
  }
];

const SALARY_COMPANY_EXPORT_LABEL_BY_KEY = SALARY_COMPANY_EXPORT_SECTIONS.reduce((result, section) => {
  if (section.children) {
    section.children.forEach((child) => {
      result[child.key] = child.label;
    });
    return result;
  }
  result[section.key] = section.label;
  return result;
}, {});

function getSalaryCompanyExportLabel(column = {}) {
  return column.label || SALARY_COMPANY_EXPORT_LABEL_BY_KEY[column.key] || column.key || "";
}

function getSalaryCompanyExportMeta(selectedColumns = []) {
  const normalizedSelectedColumns = Array.isArray(selectedColumns) && selectedColumns.length > 0
    ? selectedColumns
    : SALARY_COMPANY_EXPORT_SECTIONS.reduce((result, section) => {
      if (section.children) {
        return result.concat(section.children.map((child) => child.key));
      }
      result.push(section.key);
      return result;
    }, []);
  const selectedSet = new Set([
    "stt",
    "employee_name",
    ...normalizedSelectedColumns,
  ]);
  const sections = SALARY_COMPANY_EXPORT_SECTIONS.map((section) => {
    if (section.children) {
      const children = section.children.filter((child) => selectedSet.has(child.key));
      return children.length > 0 ? { ...section, children } : null;
    }
    return selectedSet.has(section.key) ? { ...section } : null;
  }).filter(Boolean);
  const columns = sections.reduce((result, section) => {
    if (section.children) {
      return result.concat(section.children);
    }
    result.push(section);
    return result;
  }, []);
  const headerRows = [
    sections.map((section) => {
      if (section.children) {
        return { label: getSalaryCompanyExportLabel(section), colspan: section.children.length };
      }
      return { label: getSalaryCompanyExportLabel(section), rowspan: 2 };
    }),
    sections.reduce((result, section) => {
      if (section.children) {
        return result.concat(section.children.map((child) => getSalaryCompanyExportLabel(child)));
      }
      return result;
    }, [])
  ];
  return {
    sections,
    columns,
    headerRows
  };
}

function writeSalaryCompanyExcelHeader(worksheet, sections = []) {
  let colIndex = 1;
  sections.forEach((section) => {
    if (section.children) {
      const startCol = colIndex;
      const endCol = colIndex + section.children.length - 1;
      worksheet.mergeCells(2, startCol, 2, endCol);
      worksheet.getRow(2).getCell(startCol).value = getSalaryCompanyExportLabel(section);
      section.children.forEach((child, childIndex) => {
        worksheet.getRow(3).getCell(startCol + childIndex).value = getSalaryCompanyExportLabel(child);
      });
      colIndex = endCol + 1;
      return;
    }

    worksheet.mergeCells(2, colIndex, 3, colIndex);
    worksheet.getRow(2).getCell(colIndex).value = getSalaryCompanyExportLabel(section);
    colIndex += 1;
  });
}

function getSalaryCompanyFreezeColumnCount(columns = []) {
  let count = 0;
  for (let i = 0; i < columns.length; i++) {
    if (columns[i].fixed) {
      count += 1;
      continue;
    }
    break;
  }
  return count;
}

MethodService.exportSalaryCompanyExcel = (rows = [], options = {}) => {
  const exportMeta = getSalaryCompanyExportMeta(options.selectedColumns || []);
  const visibleColumns = exportMeta.columns;
  if (visibleColumns.length === 0) {
    return;
  }
  let workbook = MethodService.createWookbook();
  let worksheet = workbook.addWorksheet("Bảng lương công ty", {
    views: [{
      state: "frozen",
      xSplit: getSalaryCompanyFreezeColumnCount(visibleColumns),
      ySplit: 3
    }]
  });
  worksheet.pageSetup = {
    paperSize: 9,
    orientation: "landscape",
    fitToPage: true,
    fitToWidth: 1,
    fitToHeight: 0,
    margins: {
      left: 0.3,
      right: 0.3,
      top: 0.4,
      bottom: 0.4,
      header: 0.2,
      footer: 0.2
    }
  };
  const periodName = options.periodName || "";
  worksheet.columns = visibleColumns.map((item) => ({
    key: item.key,
    width: item.width
  }));
  const lastCol = visibleColumns.length;
  worksheet.mergeCells(1, 1, 1, lastCol);
  worksheet.getCell(1, 1).value = "Bảng lương công ty" + (periodName ? " - " + periodName : "");
  writeSalaryCompanyExcelHeader(worksheet, exportMeta.sections);
  worksheet.getRow(2).height = 28;
  worksheet.getRow(3).height = 38;
  rows.forEach((row, rowIndex) => {
    const item = {};
    visibleColumns.forEach((column) => {
      if (column.key === "stt") {
        item[column.key] = rowIndex + 1;
        return;
      }
      item[column.key] = row && row[column.key] !== undefined && row[column.key] !== null
        ? row[column.key]
        : "";
    });
    worksheet.addRow(item);
  });
  visibleColumns
    .filter((item) => item.format === "currency")
    .forEach((item) => {
      worksheet.getColumn(item.key).numFmt = '#,##0;[Red]-#,##0';
    });
  worksheet.eachRow({ includeEmpty: true }, (row, rowNumber) => {
    row.eachCell((cell) => {
      if (rowNumber === 1) {
        cell.font = { bold: true, size: 14 };
        cell.alignment = {
          vertical: "middle",
          horizontal: "center",
          wrapText: true
        };
      } else if (rowNumber === 2 || rowNumber === 3) {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFE162" }
        };
        cell.font = { bold: true };
        cell.alignment = {
          vertical: "middle",
          horizontal: "center",
          wrapText: true
        };
      } else {
        cell.alignment = {
          vertical: "middle",
          wrapText: true
        };
      }
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" }
      };
    });
  });
  saveExcelWorkbook(
    workbook,
    "Bảng lương công ty" + (periodName ? "_" + periodName.replace(/\s+/g, "_") : "") + ".xlsx"
  );
}



MethodService.exportSalaryCompanyExcelByColumns = (rows = [], options = {}) => {
  const exportMeta = getSalaryCompanyExportMeta(options.selectedColumns || []);
  const visibleColumns = exportMeta.columns;
  if (visibleColumns.length === 0) {
    return;
  }
  let workbook = MethodService.createWookbook();
  let worksheet = workbook.addWorksheet("Bảng lương công ty", {
    views: [{
      state: "frozen",
      xSplit: getSalaryCompanyFreezeColumnCount(visibleColumns),
      ySplit: 3
    }]
  });
  worksheet.pageSetup = {
    paperSize: 9,
    orientation: "landscape",
    fitToPage: true,
    fitToWidth: 1,
    fitToHeight: 0,
    margins: {
      left: 0.3,
      right: 0.3,
      top: 0.4,
      bottom: 0.4,
      header: 0.2,
      footer: 0.2
    }
  };
  const periodName = options.periodName || "";
  worksheet.columns = visibleColumns.map((item) => ({
    key: item.key,
    width: item.width
  }));
  const lastCol = visibleColumns.length;
  worksheet.mergeCells(1, 1, 1, lastCol);
  worksheet.getCell(1, 1).value = "Bảng lương công ty" + (periodName ? " - " + periodName : "");

  writeSalaryCompanyExcelHeader(worksheet, exportMeta.sections);

  worksheet.getRow(2).height = 28;
  worksheet.getRow(3).height = 38;

  rows.forEach((row, rowIndex) => {
    const item = {};
    visibleColumns.forEach((column) => {
      if (column.key === "stt") {
        item[column.key] = rowIndex + 1;
        return;
      }
      item[column.key] = row && row[column.key] !== undefined && row[column.key] !== null
        ? row[column.key]
        : "";
    });
    worksheet.addRow(item);
  });

  visibleColumns
    .filter((item) => item.format === "currency")
    .forEach((item) => {
      worksheet.getColumn(item.key).numFmt = '#,##0;[Red]-#,##0';
    });

  worksheet.eachRow({ includeEmpty: true }, (row, rowNumber) => {
    row.eachCell((cell) => {
      if (rowNumber === 1) {
        cell.font = { bold: true, size: 14 };
        cell.alignment = {
          vertical: "middle",
          horizontal: "center",
          wrapText: true
        };
      } else if (rowNumber === 2 || rowNumber === 3) {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFE162" }
        };
        cell.font = { bold: true };
        cell.alignment = {
          vertical: "middle",
          horizontal: "center",
          wrapText: true
        };
      } else {
        cell.alignment = {
          vertical: "middle",
          wrapText: true
        };
      }
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" }
      };
    });
  });

  saveExcelWorkbook(
    workbook,
    "Bảng lương công ty" + (periodName ? "_" + periodName.replace(/\s+/g, "_") : "") + ".xlsx"
  );
}

MethodService.exportSalaryCompanyWordByColumns = (rows = [], options = {}) => {
  const exportMeta = getSalaryCompanyExportMeta(options.selectedColumns || []);
  const visibleColumns = exportMeta.columns;
  if (visibleColumns.length === 0) {
    return;
  }
  const periodName = options.periodName || "";
  const wordOrientation = options.wordOrientation || "landscape";
  const headerRows = exportMeta.headerRows;
  const dataRows = rows.map((row, rowIndex) => (
    visibleColumns.map((column) => {
      if (column.key === "stt") {
        return rowIndex + 1;
      }
      return row && row[column.key] !== undefined && row[column.key] !== null
        ? row[column.key]
        : "";
    })
  ));
  exportHtmlTableToWord({
    title: `BẢNG LƯƠNG CÔNG TY${periodName ? ` - ${periodName}` : ""}`,
    headerRows,
    rows: dataRows,
    fileName: `Bảng_lương_công_ty${periodName ? "_" + periodName.replace(/\s+/g, "_") : ""}.doc`,
    orientation: wordOrientation
  });
}

MethodService.exportSalaryImportData = (rows = [], options = {}) => {
  let workbook = MethodService.createWookbook();
  let worksheet = workbook.addWorksheet("Bảng lương", {
    views: [{ state: "frozen", xSplit: 2, ySplit: 1 }]
  });
  worksheet.columns = [
    { header: "Mã nhân viên", key: "employee_no", width: 23 },
    { header: "Họ và tên", key: "last_name", width: 30 },
    { header: "Lương cơ bản", key: "space0", width: 20 },
    { header: "Lương thực tế", key: "actual_salary", width: 20 },
    { header: "Phụ cấp trách nhiệm", key: "space1", width: 20 },
    { header: "Phụ cấp ăn trưa", key: "space2", width: 20 },
    { header: "Phụ cấp điện thoại", key: "space3", width: 20 },
    { header: "Phụ cấp xăng xe", key: "space4", width: 20 },
    { header: "Phụ cấp", key: "space5", width: 20 },
    { header: "Thưởng tháng", key: "space6", width: 20 },
    { header: "Phụ cấp thâm niên", key: "space7", width: 20 },
    { header: "Bảo hiểm xã hội (8%)", key: "space8", width: 17 },
    { header: "Bảo hiểm y tế (1,5%)", key: "space9", width: 17 },
    { header: "Bảo hiểm thất nghiệp (1%)", key: "space10", width: 20 },
    { header: "Bảo hiểm bắt buộc", key: "space11", width: 20 },
    { header: "Thuế thu nhập cá nhân", key: "space12", width: 20 },
    { header: "Tạm ứng", key: "space13", width: 20 },
    { header: "Khác", key: "space14", width: 20 },
    { header: "Tổng lương thực nhận (*)", key: "space15", width: 20 },
  ];
  rows.forEach((item) => worksheet.addRow(item));
  MethodService.styleRowExcel(worksheet);
  saveExcelWorkbook(
    workbook,
    `Du_lieu_luong${options.periodName ? "_" + options.periodName.replace(/\s+/g, "_") : ""}.xlsx`
  );
}

MethodService.exportTaxImportData = (rows = [], options = {}) => {
  let workbook = MethodService.createWookbook();
  let worksheet = workbook.addWorksheet("Bảng thuế", {
    views: [{ state: "frozen", xSplit: 2, ySplit: 1 }]
  });
  worksheet.columns = [
    { header: "Mã nhân viên (*)", key: "employee_no", width: 23 },
    { header: "Họ và tên", key: "last_name", width: 30 },
    { header: "Thu nhập chịu thuế", key: "space0", width: 25, style: { numFmt: "#,##0" } },
    { header: "Giảm trừ gia cảnh", key: "space1", width: 25, style: { numFmt: "#,##0" } },
    { header: "Ủng hộ", key: "space2", width: 25, style: { numFmt: "#,##0" } },
    { header: "Bảo hiểm bắt buộc", key: "space3", width: 25, style: { numFmt: "#,##0" } },
    { header: "Thu nhập tính thuế", key: "space4", width: 25, style: { numFmt: "#,##0" } },
    { header: "Tỷ lệ giảm thuế TNCN do có TN tại khu kinh tế", key: "space5", width: 25 },
  ];
  rows.forEach((item) => worksheet.addRow(item));
  MethodService.styleRowExcel(worksheet);
  saveExcelWorkbook(
    workbook,
    `Du_lieu_thue${options.periodName ? "_" + options.periodName.replace(/\s+/g, "_") : ""}.xlsx`
  );
}

MethodService.exportInsuranceImportData = (rows = [], options = {}) => {
  let workbook = MethodService.createWookbook();
  let worksheet = workbook.addWorksheet("Bảng bảo hiểm", {
    views: [{ state: "frozen", xSplit: 2, ySplit: 1 }]
  });
  worksheet.columns = [
    { header: "Mã nhân viên (*)", key: "employee_no", width: 23 },
    { header: "Họ và tên", key: "last_name", width: 30 },
    { header: "Bảo hiểm xã hội", key: "space0", width: 25, style: { numFmt: "#,##0" } },
    { header: "Bảo hiểm y tế", key: "space1", width: 25, style: { numFmt: "#,##0" } },
    { header: "Bảo hiểm thất nghiệp", key: "space2", width: 25, style: { numFmt: "#,##0" } },
  ];
  rows.forEach((item) => worksheet.addRow(item));
  MethodService.styleRowExcel(worksheet);
  saveExcelWorkbook(
    workbook,
    `Du_lieu_bao_hiem${options.periodName ? "_" + options.periodName.replace(/\s+/g, "_") : ""}.xlsx`
  );
}

MethodService.exportSalaryImportDataWord = (rows = [], options = {}) => {
  const wordOrientation = options.wordOrientation || "landscape";
  exportHtmlTableToWord({
    title: "DỮ LIỆU LƯƠNG",
    subtitle: options.metaText || "",
    headers: [
      "Mã nhân viên", "Họ và tên", "Lương cơ bản", "Phụ cấp trách nhiệm",
      "Phụ cấp ăn trưa", "Phụ cấp điện thoại", "Phụ cấp xăng xe", "Phụ cấp",
      "Thưởng tháng", "Phụ cấp thâm niên", "Bảo hiểm xã hội (8%)", "Bảo hiểm y tế (1,5%)",
      "Bảo hiểm thất nghiệp (1%)", "Bảo hiểm bắt buộc", "Thuế thu nhập cá nhân",
      "Tạm ứng", "Khác", "Tổng lương thực nhận"
    ],
    rows: rows.map((item) => [
      item.employee_no, item.last_name, item.space0, item.space1, item.space2, item.space3,
      item.space4, item.space5, item.space6, item.space7, item.space8, item.space9,
      item.space10, item.space11, item.space12, item.space13, item.space14, item.space15
    ]),
    fileName: `Du_lieu_luong${options.periodName ? "_" + options.periodName.replace(/\s+/g, "_") : ""}.doc`,
    orientation: wordOrientation
  });
}

MethodService.exportTaxImportDataWord = (rows = [], options = {}) => {
  const wordOrientation = options.wordOrientation || "landscape";
  exportHtmlTableToWord({
    title: "DỮ LIỆU THUẾ",
    subtitle: options.metaText || "",
    headers: [
      "Mã nhân viên (*)", "Họ và tên", "Thu nhập chịu thuế", "Giảm trừ gia cảnh",
      "Ủng hộ", "Bảo hiểm bắt buộc", "Thu nhập tính thuế",
      "Tỷ lệ giảm thuế TNCN do có TN tại khu kinh tế"
    ],
    rows: rows.map((item) => [
      item.employee_no, item.last_name, item.space0, item.space1,
      item.space2, item.space3, item.space4, item.space5
    ]),
    fileName: `Du_lieu_thue${options.periodName ? "_" + options.periodName.replace(/\s+/g, "_") : ""}.doc`,
    orientation: wordOrientation
  });
}

MethodService.exportInsuranceImportDataWord = (rows = [], options = {}) => {
  const wordOrientation = options.wordOrientation || "landscape";
  exportHtmlTableToWord({
    title: "DỮ LIỆU BẢO HIỂM",
    subtitle: options.metaText || "",
    headers: [
      "Mã nhân viên (*)", "Họ và tên", "Bảo hiểm xã hội", "Bảo hiểm y tế", "Bảo hiểm thất nghiệp"
    ],
    rows: rows.map((item) => [
      item.employee_no, item.last_name, item.space0, item.space1, item.space2
    ]),
    fileName: `Du_lieu_bao_hiem${options.periodName ? "_" + options.periodName.replace(/\s+/g, "_") : ""}.doc`,
    orientation: wordOrientation
  });
}

MethodService.getHeader = (numberDay, today) => {
  let header = [
    { header: "Mã nhân viên", key: "employee_no", width: 17 },
    { header: "Tên nhân viên", key: "employee_name", width: 27 },
    { header: "Chi nhánh", key: "branch_name", width: 23 },
    { header: "Phòng ban", key: "department_name", width: 23 },
    { header: "Chức vụ", key: "position_name", width: 23 },
    { header: "Mã ca làm việc", key: "shift_code", width: 12 },
    { header: "Tổng công", key: "total_work", width: 12 },
  ];
  for (let i = 1; i <= numberDay; i++) {
    for (let j = 0; j < 3; j++) {
      let nameK = "";
      if (j == 0) {
        nameK = "work_" //go_late_
      } else if (j == 1) {
        nameK = "go_late_" //go_home_
      } else if (j == 2) {
        nameK = "go_home_" //work_
      }
      header.push({
        header: (i < 10 ? "0" + i.toString() : i.toString()) + "/" + (today.getMonth() + 1) + "/" + today.getFullYear(), key: nameK + i, width: 10
      })
    }
  }
  return header
}

MethodService.getCellName = (worksheet, rowIndex, cellIndex) => {
  return worksheet.getRow(rowIndex).getCell(cellIndex)._address;
}

MethodService.checkValidate = (type, e) => {
  if (type == "blur" || type == "change") {
    if (e) {
      $(".el-select-validate").addClass("input-error");
      setTimeout(() => {
        let errorElement = $(".el-select-validate  > .el-form-item__error");
        if (errorElement.length == 0) {
          $(".input-error").append(`<div class="el-form-item__error"> Vui lòng chọn giá trị </div>`);
        }
      }, 0.1);
    } else {
      $(".el-select-validate").removeClass("input-error");
      $(".el-select-validate  > .el-form-item__error").remove();
    }
  } else if (type == "clear") {
    $(".el-select-validate  > .el-form-item__error").remove();
  }
}

async function applyScopeFilter(dataFilter, currentUser, isCompanyModule = false) {
  if (!currentUser) return dataFilter;

  if (isCompanyModule) {
    if (currentUser.corporation_id) {
      const scopeFilter = `corporation_id=${currentUser.corporation_id}`;
      dataFilter.filters = [dataFilter.filters, scopeFilter].filter(Boolean).join('&');
    }
  }

  return dataFilter;
}
MethodService.applyScopeFilter = applyScopeFilter;
export default MethodService;
